/*!
 * headroom.js v0.11.0 - Give your page some headroom. Hide your header until you need it
 * Copyright (c) 2020 Nick Williams - http://wicky.nillia.ms/headroom.js
 * License: MIT
 */

!function(t,n){"object"==typeof exports&&"undefined"!=typeof module?module.exports=n():"function"==typeof define&&define.amd?define(n):(t=t||self).Headroom=n()}(this,function(){"use strict";function t(){return"undefined"!=typeof window}function d(t){return function(t){return t&&t.document&&function(t){return 9===t.nodeType}(t.document)}(t)?function(t){var n=t.document,o=n.body,s=n.documentElement;return{scrollHeight:function(){return Math.max(o.scrollHeight,s.scrollHeight,o.offsetHeight,s.offsetHeight,o.clientHeight,s.clientHeight)},height:function(){return t.innerHeight||s.clientHeight||o.clientHeight},scrollY:function(){return void 0!==t.pageYOffset?t.pageYOffset:(s||o.parentNode||o).scrollTop}}}(t):function(t){return{scrollHeight:function(){return Math.max(t.scrollHeight,t.offsetHeight,t.clientHeight)},height:function(){return Math.max(t.offsetHeight,t.clientHeight)},scrollY:function(){return t.scrollTop}}}(t)}function n(t,s,e){var n,o=function(){var n=!1;try{var t={get passive(){n=!0}};window.addEventListener("test",t,t),window.removeEventListener("test",t,t)}catch(t){n=!1}return n}(),i=!1,r=d(t),l=r.scrollY(),a={};function c(){var t=Math.round(r.scrollY()),n=r.height(),o=r.scrollHeight();a.scrollY=t,a.lastScrollY=l,a.direction=l<t?"down":"up",a.distance=Math.abs(t-l),a.isOutOfBounds=t<0||o<t+n,a.top=t<=s.offset,a.bottom=o<=t+n,a.toleranceExceeded=a.distance>s.tolerance[a.direction],e(a),l=t,i=!1}function h(){i||(i=!0,n=requestAnimationFrame(c))}var u=!!o&&{passive:!0,capture:!1};return t.addEventListener("scroll",h,u),c(),{destroy:function(){cancelAnimationFrame(n),t.removeEventListener("scroll",h,u)}}}function o(t,n){n=n||{},Object.assign(this,o.options,n),this.classes=Object.assign({},o.options.classes,n.classes),this.elem=t,this.tolerance=function(t){return t===Object(t)?t:{down:t,up:t}}(this.tolerance),this.initialised=!1,this.frozen=!1}return o.prototype={constructor:o,init:function(){return o.cutsTheMustard&&!this.initialised&&(this.addClass("initial"),this.initialised=!0,setTimeout(function(t){t.scrollTracker=n(t.scroller,{offset:t.offset,tolerance:t.tolerance},t.update.bind(t))},100,this)),this},destroy:function(){this.initialised=!1,Object.keys(this.classes).forEach(this.removeClass,this),this.scrollTracker.destroy()},unpin:function(){!this.hasClass("pinned")&&this.hasClass("unpinned")||(this.addClass("unpinned"),this.removeClass("pinned"),this.onUnpin&&this.onUnpin.call(this))},pin:function(){this.hasClass("unpinned")&&(this.addClass("pinned"),this.removeClass("unpinned"),this.onPin&&this.onPin.call(this))},freeze:function(){this.frozen=!0,this.addClass("frozen")},unfreeze:function(){this.frozen=!1,this.removeClass("frozen")},top:function(){this.hasClass("top")||(this.addClass("top"),this.removeClass("notTop"),this.onTop&&this.onTop.call(this))},notTop:function(){this.hasClass("notTop")||(this.addClass("notTop"),this.removeClass("top"),this.onNotTop&&this.onNotTop.call(this))},bottom:function(){this.hasClass("bottom")||(this.addClass("bottom"),this.removeClass("notBottom"),this.onBottom&&this.onBottom.call(this))},notBottom:function(){this.hasClass("notBottom")||(this.addClass("notBottom"),this.removeClass("bottom"),this.onNotBottom&&this.onNotBottom.call(this))},shouldUnpin:function(t){return"down"===t.direction&&!t.top&&t.toleranceExceeded},shouldPin:function(t){return"up"===t.direction&&t.toleranceExceeded||t.top},addClass:function(t){this.elem.classList.add.apply(this.elem.classList,this.classes[t].split(" "))},removeClass:function(t){this.elem.classList.remove.apply(this.elem.classList,this.classes[t].split(" "))},hasClass:function(t){return this.classes[t].split(" ").every(function(t){return this.classList.contains(t)},this.elem)},update:function(t){t.isOutOfBounds||!0!==this.frozen&&(t.top?this.top():this.notTop(),t.bottom?this.bottom():this.notBottom(),this.shouldUnpin(t)?this.unpin():this.shouldPin(t)&&this.pin())}},o.options={tolerance:{up:0,down:0},offset:0,scroller:t()?window:null,classes:{frozen:"headroom--frozen",pinned:"headroom--pinned",unpinned:"headroom--unpinned",top:"headroom--top",notTop:"headroom--not-top",bottom:"headroom--bottom",notBottom:"headroom--not-bottom",initial:"headroom"}},o.cutsTheMustard=!!(t()&&function(){}.bind&&"classList"in document.documentElement&&Object.assign&&Object.keys&&requestAnimationFrame),o});

/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'jquery-bridget/jquery-bridget',[ 'jquery' ], function( jQuery ) {
      return factory( window, jQuery );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('jquery')
    );
  } else {
    // browser global
    window.jQueryBridget = factory(
      window,
      window.jQuery
    );
  }

}( window, function factory( window, jQuery ) {
'use strict';

// ----- utils ----- //

var arraySlice = Array.prototype.slice;

// helper function for logging errors
// $.error breaks jQuery chaining
var console = window.console;
var logError = typeof console == 'undefined' ? function() {} :
  function( message ) {
    console.error( message );
  };

// ----- jQueryBridget ----- //

function jQueryBridget( namespace, PluginClass, $ ) {
  $ = $ || jQuery || window.jQuery;
  if ( !$ ) {
    return;
  }

  // add option method -> $().plugin('option', {...})
  if ( !PluginClass.prototype.option ) {
    // option setter
    PluginClass.prototype.option = function( opts ) {
      // bail out if not an object
      if ( !$.isPlainObject( opts ) ){
        return;
      }
      this.options = $.extend( true, this.options, opts );
    };
  }

  // make jQuery plugin
  $.fn[ namespace ] = function( arg0 /*, arg1 */ ) {
    if ( typeof arg0 == 'string' ) {
      // method call $().plugin( 'methodName', { options } )
      // shift arguments by 1
      var args = arraySlice.call( arguments, 1 );
      return methodCall( this, arg0, args );
    }
    // just $().plugin({ options })
    plainCall( this, arg0 );
    return this;
  };

  // $().plugin('methodName')
  function methodCall( $elems, methodName, args ) {
    var returnValue;
    var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';

    $elems.each( function( i, elem ) {
      // get instance
      var instance = $.data( elem, namespace );
      if ( !instance ) {
        logError( namespace + ' not initialized. Cannot call methods, i.e. ' +
          pluginMethodStr );
        return;
      }

      var method = instance[ methodName ];
      if ( !method || methodName.charAt(0) == '_' ) {
        logError( pluginMethodStr + ' is not a valid method' );
        return;
      }

      // apply method, get return value
      var value = method.apply( instance, args );
      // set return value if value is returned, use only first value
      returnValue = returnValue === undefined ? value : returnValue;
    });

    return returnValue !== undefined ? returnValue : $elems;
  }

  function plainCall( $elems, options ) {
    $elems.each( function( i, elem ) {
      var instance = $.data( elem, namespace );
      if ( instance ) {
        // set options & init
        instance.option( options );
        instance._init();
      } else {
        // initialize new instance
        instance = new PluginClass( elem, options );
        $.data( elem, namespace, instance );
      }
    });
  }

  updateJQuery( $ );

}

// ----- updateJQuery ----- //

// set $.bridget for v1 backwards compatibility
function updateJQuery( $ ) {
  if ( !$ || ( $ && $.bridget ) ) {
    return;
  }
  $.bridget = jQueryBridget;
}

updateJQuery( jQuery || window.jQuery );

// -----  ----- //

return jQueryBridget;

}));

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'ev-emitter/ev-emitter',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {



function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'get-size/get-size',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'desandro-matches-selector/matches-selector',factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( 'fizzy-ui-utils/utils',[
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {



var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'outlayer/item',[
        'ev-emitter/ev-emitter',
        'get-size/get-size'
      ],
      factory
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  var x = parseFloat( xValue );
  var y = parseFloat( yValue );
  // convert percent to pixels
  var layoutSize = this.layout.size;
  if ( xValue.indexOf('%') != -1 ) {
    x = ( x / 100 ) * layoutSize.width;
  }
  if ( yValue.indexOf('%') != -1 ) {
    y = ( y / 100 ) * layoutSize.height;
  }
  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var didNotMove = x == this.position.x && y == this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseFloat( x );
  this.position.y = parseFloat( y );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));

/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( 'outlayer/outlayer',[
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
      ],
      function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));

/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {



// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  var proto = Masonry.prototype;

  proto._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
    this.horizontalColIndex = 0;
  };

  proto.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  proto.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  proto._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ?
      '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[ colPosMethod ]( colSpan, item );
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for ( var i = colPosition.col; i < setMax; i++ ) {
      this.colYs[i] = setHeight;
    }

    return position;
  };

  proto._getTopColPosition = function( colSpan ) {
    var colGroup = this._getTopColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );

    return {
      col: colGroup.indexOf( minimumY ),
      y: minimumY,
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      colGroup[i] = this._getColGroupY( i, colSpan );
    }
    return colGroup;
  };

  proto._getColGroupY = function( col, colSpan ) {
    if ( colSpan < 2 ) {
      return this.colYs[ col ];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice( col, col + colSpan );
    // and get the max value of the array
    return Math.max.apply( Math, groupColYs );
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function( colSpan, item ) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

    return {
      col: col,
      y: this._getColGroupY( col, colSpan ),
    };
  };

  proto._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  proto._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  proto._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  proto.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));

/*
 jQuery placeholderTypewriter plugin
 ===================================
 Author: Bjoern Diekert <https://github.com/bdiekert>
 Version: 1.0
 License: Unlicense <http://unlicense.org>
 */
(function ($) {
  "use strict";

  $.fn.placeholderTypewriter = function (options) {

    // Plugin Settings
    var settings = $.extend({
      delay: 50,
      pause: 1000,
      text: []
    }, options);

    // Type given string in placeholder
    function typeString($target, index, cursorPosition, callback) {

      // Get text
      var text = settings.text[index];

      // Get placeholder, type next character
      var placeholder = $target.attr('placeholder');
      $target.attr('placeholder', placeholder + text[cursorPosition]);

      // Type next character
      if (cursorPosition < text.length - 1) {
        setTimeout(function () {
          typeString($target, index, cursorPosition + 1, callback);
        }, settings.delay);
        return true;
      }

      // Callback if animation is finished
      callback();
    }

    // Delete string in placeholder
    function deleteString($target, callback) {

      // Get placeholder
      var placeholder = $target.attr('placeholder');
      var length = placeholder.length;

      // Delete last character
      $target.attr('placeholder', placeholder.substr(0, length - 1));

      // Delete next character
      if (length > 1) {
        setTimeout(function () {
          deleteString($target, callback)
        }, settings.delay);
        return true;
      }

      // Callback if animation is finished
      callback();
    }

    // Loop typing animation
    function loopTyping($target, index) {

      // Clear Placeholder
      $target.attr('placeholder', '');

      // Type string
      typeString($target, index, 0, function () {

        // Pause before deleting string
        setTimeout(function () {

          // Delete string
          deleteString($target, function () {
            // Start loop over
            loopTyping($target, (index + 1) % settings.text.length)
          })

        }, settings.pause);
      })

    }

    // Run placeholderTypewriter on every given field
    return this.each(function () {

      loopTyping($(this), 0);
    });

  };

}(jQuery));
var scripts=document.getElementsByTagName("script"),tarteaucitronPath=(document.currentScript||scripts[scripts.length-1]).src.split("?")[0],tarteaucitronForceCDN=tarteaucitronForceCDN===undefined?"":tarteaucitronForceCDN,tarteaucitronUseMin=tarteaucitronUseMin===undefined?"":tarteaucitronUseMin,cdn=tarteaucitronForceCDN===""?tarteaucitronPath.split("/").slice(0,-1).join("/")+"/":tarteaucitronForceCDN,alreadyLaunch=alreadyLaunch===undefined?0:alreadyLaunch,tarteaucitronForceLanguage=tarteaucitronForceLanguage===undefined?"":tarteaucitronForceLanguage,tarteaucitronForceExpire=tarteaucitronForceExpire===undefined?"":tarteaucitronForceExpire,tarteaucitronCustomText=tarteaucitronCustomText===undefined?"":tarteaucitronCustomText,tarteaucitronExpireInDay=tarteaucitronExpireInDay===undefined||typeof tarteaucitronExpireInDay!=="boolean"?true:tarteaucitronExpireInDay,timeExpire=31536e6,tarteaucitronProLoadServices,tarteaucitronNoAdBlocker=false,tarteaucitronIsLoaded=false;var tarteaucitron={version:1.18,cdn:cdn,user:{},lang:{},services:{},added:[],idprocessed:[],state:{},launch:[],parameters:{},isAjax:false,reloadThePage:false,events:{init:function(){},load:function(){}},init:function(params){"use strict";var origOpen;tarteaucitron.parameters=params;if(alreadyLaunch===0){alreadyLaunch=1;if(window.addEventListener){window.addEventListener("load",function(){tarteaucitron.initEvents.loadEvent(false)},false);window.addEventListener("scroll",function(){tarteaucitron.initEvents.scrollEvent()},false);window.addEventListener("keydown",function(evt){tarteaucitron.initEvents.keydownEvent(false,evt)},false);window.addEventListener("hashchange",function(){tarteaucitron.initEvents.hashchangeEvent()},false);window.addEventListener("resize",function(){tarteaucitron.initEvents.resizeEvent()},false)}else{window.attachEvent("onload",function(){tarteaucitron.initEvents.loadEvent(true)});window.attachEvent("onscroll",function(){tarteaucitron.initEvents.scrollEvent()});window.attachEvent("onkeydown",function(evt){tarteaucitron.initEvents.keydownEvent(true,evt)});window.attachEvent("onhashchange",function(){tarteaucitron.initEvents.hashchangeEvent()});window.attachEvent("onresize",function(){tarteaucitron.initEvents.resizeEvent()})}if(typeof XMLHttpRequest!=="undefined"){origOpen=XMLHttpRequest.prototype.open;XMLHttpRequest.prototype.open=function(){if(window.addEventListener){this.addEventListener("load",function(){if(typeof tarteaucitronProLoadServices==="function"){tarteaucitronProLoadServices()}},false)}else if(typeof this.attachEvent!=="undefined"){this.attachEvent("onload",function(){if(typeof tarteaucitronProLoadServices==="function"){tarteaucitronProLoadServices()}})}else{if(typeof tarteaucitronProLoadServices==="function"){setTimeout(tarteaucitronProLoadServices,1e3)}}try{origOpen.apply(this,arguments)}catch(err){}}}}if(tarteaucitron.events.init){tarteaucitron.events.init()}},initEvents:{loadEvent:function(isOldBrowser){tarteaucitron.load();tarteaucitron.fallback(["tarteaucitronOpenPanel"],function(elem){if(isOldBrowser){elem.attachEvent("onclick",function(event){tarteaucitron.userInterface.openPanel();event.preventDefault()})}else{elem.addEventListener("click",function(event){tarteaucitron.userInterface.openPanel();event.preventDefault()},false)}},true)},keydownEvent:function(isOldBrowser,evt){if(evt.keyCode===27){tarteaucitron.userInterface.closePanel()}if(isOldBrowser){if(evt.keyCode===9&&focusableEls.indexOf(evt.target)>=0){if(evt.shiftKey){if(document.activeElement===firstFocusableEl){lastFocusableEl.focus();evt.preventDefault()}}else{if(document.activeElement===lastFocusableEl){firstFocusableEl.focus();evt.preventDefault()}}}}},hashchangeEvent:function(){if(document.location.hash===tarteaucitron.hashtag&&tarteaucitron.hashtag!==""){tarteaucitron.userInterface.openPanel()}},resizeEvent:function(){var tacElem=document.getElementById("tarteaucitron");var tacCookieContainer=document.getElementById("tarteaucitronCookiesListContainer");if(tacElem&&tacElem.style.display==="block"){tarteaucitron.userInterface.jsSizing("main")}if(tacCookieContainer&&tacCookieContainer.style.display==="block"){tarteaucitron.userInterface.jsSizing("cookie")}},scrollEvent:function(){var scrollPos=window.pageYOffset||document.documentElement.scrollTop;var heightPosition;var tacPercentage=document.getElementById("tarteaucitronPercentage");var tacAlertBig=document.getElementById("tarteaucitronAlertBig");if(tacAlertBig&&!tarteaucitron.highPrivacy){if(tacAlertBig.style.display==="block"){heightPosition=tacAlertBig.offsetHeight+"px";if(scrollPos>screen.height*2){tarteaucitron.userInterface.respondAll(true)}else if(scrollPos>screen.height/2){document.getElementById("tarteaucitronDisclaimerAlert").innerHTML="<strong>"+tarteaucitron.lang.alertBigScroll+"</strong> "+tarteaucitron.lang.alertBig}if(tacPercentage){if(tarteaucitron.orientation==="top"){tacPercentage.style.top=heightPosition}else{tacPercentage.style.bottom=heightPosition}tacPercentage.style.width=100/(screen.height*2)*scrollPos+"%"}}}}},load:function(){"use strict";if(tarteaucitronIsLoaded===true){return}var cdn=tarteaucitron.cdn,language=tarteaucitron.getLanguage(),useMinifiedJS=cdn.indexOf("cdn.jsdelivr.net")>=0||tarteaucitronPath.indexOf(".min.")>=0||tarteaucitronUseMin!=="",pathToLang=cdn+"lang/tarteaucitron."+language+(useMinifiedJS?".min":"")+".js",pathToServices=cdn+"tarteaucitron.services"+(useMinifiedJS?".min":"")+".js",linkElement=document.createElement("link"),defaults={adblocker:false,hashtag:"#tarteaucitron",cookieName:"tarteaucitron",highPrivacy:true,orientation:"middle",bodyPosition:"bottom",removeCredit:false,showAlertSmall:false,showDetailsOnClick:true,showIcon:true,iconPosition:"BottomRight",cookieslist:false,handleBrowserDNTRequest:false,DenyAllCta:true,AcceptAllCta:true,moreInfoLink:true,privacyUrl:"",useExternalCss:false,useExternalJs:false,mandatory:true,mandatoryCta:true,closePopup:false,groupServices:false,serviceDefaultState:"wait",googleConsentMode:true,partnersList:false,alwaysNeedConsent:false},params=tarteaucitron.parameters;tarteaucitronIsLoaded=true;if((tarteaucitron.parameters.readmoreLink!==undefined&&window.location.href==tarteaucitron.parameters.readmoreLink||window.location.href==tarteaucitron.parameters.privacyUrl)&&tarteaucitron.parameters.orientation=="middle"){tarteaucitron.parameters.orientation="bottom"}if(typeof tarteaucitronCustomPremium!=="undefined"){tarteaucitronCustomPremium()}if(params!==undefined){for(var k in defaults){if(!tarteaucitron.parameters.hasOwnProperty(k)){tarteaucitron.parameters[k]=defaults[k]}}}tarteaucitron.orientation=tarteaucitron.parameters.orientation;tarteaucitron.hashtag=tarteaucitron.parameters.hashtag;tarteaucitron.highPrivacy=tarteaucitron.parameters.highPrivacy;tarteaucitron.handleBrowserDNTRequest=tarteaucitron.parameters.handleBrowserDNTRequest;tarteaucitron.customCloserId=tarteaucitron.parameters.customCloserId;if(tarteaucitron.parameters.googleConsentMode===true){window.dataLayer=window.dataLayer||[];window.tac_gtag=function tac_gtag(){dataLayer.push(arguments)};window.tac_gtag("consent","default",{ad_storage:"denied",analytics_storage:"denied",ad_user_data:"denied",ad_personalization:"denied",wait_for_update:800});document.addEventListener("googleads_added",function(){if(tarteaucitron.added["gcmads"]===true){return}tarteaucitron.services.gcmads={key:"gcmads",type:"ads",name:"Google Ads (personalized ads)",uri:"https://support.google.com/analytics/answer/9976101",needConsent:true,cookies:[],js:function(){},fallback:function(){}};tarteaucitron.job.push("gcmads");var i,allowBtns=document.getElementsByClassName("tarteaucitronAllow"),denyBtns=document.getElementsByClassName("tarteaucitronDeny");for(i=0;i<allowBtns.length;i++){tarteaucitron.addClickEventToElement(allowBtns[i],function(){tarteaucitron.userInterface.respond(this,true)})}for(i=0;i<denyBtns.length;i++){tarteaucitron.addClickEventToElement(denyBtns[i],function(){tarteaucitron.userInterface.respond(this,false)})}});document.addEventListener("gcmads_allowed",function(){tarteaucitron.setConsent("googleads",true)});document.addEventListener("gcmads_loaded",function(){window.tac_gtag("consent","update",{ad_user_data:"granted",ad_personalization:"granted"})});document.addEventListener("gcmads_allowed",function(){window.tac_gtag("consent","update",{ad_user_data:"granted",ad_personalization:"granted"})});document.addEventListener("gcmads_disallowed",function(){window.tac_gtag("consent","update",{ad_user_data:"denied",ad_personalization:"denied"})});document.addEventListener("googleads_loaded",function(){window.tac_gtag("consent","update",{ad_storage:"granted"})});document.addEventListener("googleads_allowed",function(){window.tac_gtag("consent","update",{ad_storage:"granted"})});document.addEventListener("googleads_disallowed",function(){tarteaucitron.setConsent("gcmads",false);window.tac_gtag("consent","update",{ad_storage:"denied"})});document.addEventListener("gtag_loaded",function(){window.tac_gtag("consent","update",{analytics_storage:"granted"})});document.addEventListener("gtag_allowed",function(){window.tac_gtag("consent","update",{analytics_storage:"granted"})});document.addEventListener("gtag_disallowed",function(){window.tac_gtag("consent","update",{analytics_storage:"denied"})});window.addEventListener("tac.root_available",function(){if(typeof tarteaucitron_block!=="undefined"){tarteaucitron_block.unblock(/www\.googletagmanager\.com\/gtag\/js/);tarteaucitron_block.unblock(/www\.googleadservices\.com\/pagead\/conversion/);tarteaucitron_block.unblock(/AW-/);tarteaucitron_block.unblock(/google-analytics\.com\/analytics\.js/);tarteaucitron_block.unblock(/google-analytics\.com\/ga\.js/)}})}if(!tarteaucitron.parameters.useExternalCss){linkElement.rel="stylesheet";linkElement.type="text/css";linkElement.href=cdn+"css/tarteaucitron"+(useMinifiedJS?".min":"")+".css";document.getElementsByTagName("head")[0].appendChild(linkElement)}tarteaucitron.addInternalScript(pathToLang,"",function(){if(tarteaucitronCustomText!==""){tarteaucitron.lang=tarteaucitron.AddOrUpdate(tarteaucitron.lang,tarteaucitronCustomText)}tarteaucitron.addInternalScript(pathToServices,"",function(){if(tarteaucitron.orientation==="middle"){var customThemeMiddle=document.createElement("style"),cssRuleMiddle="div#tarteaucitronRoot.tarteaucitronBeforeVisible:before {content: '';position: fixed;width: 100%;height: 100%;background: white;top: 0;left: 0;z-index: 999;opacity: 0.5;}div#tarteaucitronAlertBig:before {content: '"+tarteaucitron.lang.middleBarHead+"';font-size: 35px;}body #tarteaucitronRoot div#tarteaucitronAlertBig {width: 60%;min-width: 285px;height: auto;margin: auto;left: 50%;top: 50%;transform: translate(-50%, -50%);box-shadow: 0 0 9000px #000;border-radius: 20px;padding: 35px 25px;}span#tarteaucitronDisclaimerAlert {padding: 0 30px;}#tarteaucitronRoot span#tarteaucitronDisclaimerAlert {margin: 10px 0 30px;display: block;text-align: center;font-size: 21px;}@media screen and (max-width: 900px) {div#tarteaucitronAlertBig button {margin: 0 auto 10px!important;display: block!important;}}";customThemeMiddle.type="text/css";if(customThemeMiddle.styleSheet){customThemeMiddle.styleSheet.cssText=cssRuleMiddle}else{customThemeMiddle.appendChild(document.createTextNode(cssRuleMiddle))}document.getElementsByTagName("head")[0].appendChild(customThemeMiddle)}if(tarteaucitron.parameters.groupServices==true){tarteaucitron.parameters.showDetailsOnClick=true}if(tarteaucitron.orientation==="popup"){var customThemePopup=document.createElement("style"),cssRulePopup="div#tarteaucitronAlertBig:before {content: '"+tarteaucitron.lang.middleBarHead+"';font-size: 22px;}body #tarteaucitronRoot div#tarteaucitronAlertBig {bottom: 0;top: auto!important;left: 8px!important;right: auto!important;transform: initial!important;border-radius: 5px 5px 0 0!important;max-width: 250px!important;width: calc(100% - 16px)!important;min-width: 0!important;padding: 25px 0;}span#tarteaucitronDisclaimerAlert {padding: 0 30px;font-size: 15px!important;}#tarteaucitronRoot span#tarteaucitronDisclaimerAlert {margin: 10px 0 30px;display: block;text-align: center;font-size: 21px;}div#tarteaucitronAlertBig button {margin: 0 auto 10px!important;display: block!important;width: calc(100% - 60px);box-sizing: border-box;}";customThemePopup.type="text/css";if(customThemePopup.styleSheet){customThemePopup.styleSheet.cssText=cssRulePopup}else{customThemePopup.appendChild(document.createTextNode(cssRulePopup))}document.getElementsByTagName("head")[0].appendChild(customThemePopup)}var body=document.body,div=document.createElement("div"),html="",index,orientation="Top",modalAttrs="",cat=["ads","analytic","api","comment","social","support","video","other","google"],i;cat=cat.sort(function(a,b){if(tarteaucitron.lang[a].title>tarteaucitron.lang[b].title){return 1}if(tarteaucitron.lang[a].title<tarteaucitron.lang[b].title){return-1}return 0});html+='<div role="heading" aria-level="1" id="tac_title" class="tac_visually-hidden">'+tarteaucitron.lang.title+"</div>";html+='<div id="tarteaucitronPremium"></div>';if(tarteaucitron.reloadThePage){html+='<button type="button" id="tarteaucitronBack" aria-label="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')" title="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')"></button>'}else{html+='<button type="button" id="tarteaucitronBack" aria-label="'+tarteaucitron.lang.close+'" title="'+tarteaucitron.lang.close+'"></button>'}html+='<div id="tarteaucitron" role="dialog" aria-modal="true" aria-labelledby="dialogTitle" tabindex="-1">';if(tarteaucitron.reloadThePage){html+='   <button type="button" id="tarteaucitronClosePanel" aria-label="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')" title="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')">'}else{html+='   <button type="button" id="tarteaucitronClosePanel">'}html+="       "+tarteaucitron.lang.close;html+="   </button>";html+='   <div id="tarteaucitronServices">';html+='      <div class="tarteaucitronLine tarteaucitronMainLine" id="tarteaucitronMainLineOffset">';html+='         <span class="tarteaucitronH1" role="heading" aria-level="1" id="dialogTitle">'+tarteaucitron.lang.title+"</span>";html+='         <div id="tarteaucitronInfo">';html+="         "+tarteaucitron.lang.disclaimer;if(tarteaucitron.parameters.privacyUrl!==""){html+="   <br/><br/>";html+='   <button type="button" id="tarteaucitronPrivacyUrlDialog" role="link">';html+="       "+tarteaucitron.lang.privacyUrl;html+="   </button>"}html+="         </div>";html+='         <div class="tarteaucitronName">';html+='            <span class="tarteaucitronH2" role="heading" aria-level="2">'+tarteaucitron.lang.all+"</span>";html+="         </div>";html+='         <div class="tarteaucitronAsk" id="tarteaucitronScrollbarAdjust">';html+='            <button type="button" id="tarteaucitronAllAllowed" class="tarteaucitronAllow">';html+='               <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.allowAll;html+="            </button> ";html+='            <button type="button" id="tarteaucitronAllDenied" class="tarteaucitronDeny">';html+='               <span class="tarteaucitronCross" aria-hidden="true"></span> '+tarteaucitron.lang.denyAll;html+="            </button>";html+="         </div>";html+="      </div>";html+='      <div class="tarteaucitronBorder">';html+='         <div class="clear"></div><ul>';if(tarteaucitron.parameters.mandatory==true){html+='<li id="tarteaucitronServicesTitle_mandatory">';html+='<div class="tarteaucitronTitle">';if(tarteaucitron.parameters.showDetailsOnClick){html+='   <button type="button" tabindex="-1"><span class="tarteaucitronPlus" aria-hidden="true"></span> '+tarteaucitron.lang.mandatoryTitle+"</button>"}else{html+='   <span class="asCatToggleBtn">'+tarteaucitron.lang.mandatoryTitle+"</span>"}html+="</div>";html+='<ul id="tarteaucitronServices_mandatory">';html+='<li class="tarteaucitronLine">';html+='   <div class="tarteaucitronName">';html+='       <span class="tarteaucitronH3" role="heading" aria-level="3">'+tarteaucitron.lang.mandatoryText+"</span>";html+='       <span class="tarteaucitronListCookies" aria-hidden="true"></span><br/>';html+="   </div>";if(tarteaucitron.parameters.mandatoryCta==true){html+='   <div class="tarteaucitronAsk">';html+='       <button type="button" class="tarteaucitronAllow" tabindex="-1" disabled>';html+='           <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.allow;html+="       </button> ";html+='       <button type="button" class="tarteaucitronDeny" tabindex="-1">';html+='           <span class="tarteaucitronCross" aria-hidden="true"></span> '+tarteaucitron.lang.deny;html+="       </button> ";html+="   </div>"}html+="</li>";html+="</ul></li>"}for(i=0;i<cat.length;i+=1){html+='         <li id="tarteaucitronServicesTitle_'+cat[i]+'" class="tarteaucitronHidden">';html+='            <div class="tarteaucitronTitle" role="heading" aria-level="2">';if(tarteaucitron.parameters.showDetailsOnClick){html+='               <button type="button" class="catToggleBtn" aria-expanded="false" data-cat="tarteaucitronDetails'+cat[i]+'"><span class="tarteaucitronPlus" aria-hidden="true"></span> '+tarteaucitron.lang[cat[i]].title+"</button>"}else{html+='               <span class="asCatToggleBtn" data-cat="tarteaucitronInlineDetails'+cat[i]+'">'+tarteaucitron.lang[cat[i]].title+"</span>"}html+="            </div>";html+='            <div id="tarteaucitronDetails'+cat[i]+'" class="tarteaucitronDetails '+(tarteaucitron.parameters.showDetailsOnClick?"tarteaucitronInfoBox":"tarteaucitronDetailsInline")+'">';html+="               "+tarteaucitron.lang[cat[i]].details;html+="            </div>";html+='         <ul id="tarteaucitronServices_'+cat[i]+'"></ul></li>'}html+='             <li id="tarteaucitronNoServicesTitle" class="tarteaucitronLine">'+tarteaucitron.lang.noServices+"</li>";html+="         </ul>";html+='         <div class="tarteaucitronHidden tarteaucitron-spacer-20" id="tarteaucitronScrollbarChild"></div>';if(tarteaucitron.parameters.removeCredit===false){html+='     <a class="tarteaucitronSelfLink" href="https://tarteaucitron.io/" rel="nofollow noreferrer noopener" target="_blank" title="tarteaucitron '+tarteaucitron.lang.newWindow+'"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAAAeCAYAAAAWwoEYAAADl0lEQVRoge1Y0W3bQAx9CjKARlC+9GVUmqDJBHEmiDyB6wkcTxBngtgTxJ0gzgQW4C/9aYOmE6g4lTQo+k6y3Rb94QOERNQd+cjj8XiGwWAwGAwGg8FgMBgMBoPB8F8RNRXe+whEKe7c36ZCAeCRxC9Rig2PUd8kPgAsoxSfQ3YAzAA8D/HwYYCb05kBKKO0teFkmbC1jlKsAnq/Abjn+QBqAIsoRS30ttwG/HNz1wH/XIxWTicLdvtW7xTAGEAMtP685CNsBTe2d/BLydfXAG57SEnMAST0zgYZSUCPk02bCvkJduIzuJzDLfPolbY+tLKmar+/8+IRePy4qdpE03qHuH8fipFb4N2+XdA3AJ/0vaQxt7s9FvkIS2XvtqnwM0rxpOQfbnE5G2LhTCmUO2fHIngOmcv+KG3HafDchB6ntwjYqenR2PqC7sOZ3E7FXHB0vqxoFyUyLh7OEH7LOGouvhhN3eIBeKXv0n5MsufdHqXcwYR5U2EbpV35lSspVPJmQj4TcgRK7jTg5IzmPUhhwM5a2WHUFCx+NgiDucmgh7idikLovHFlL0pxQ9xzX+IIP9Y6FrJsqhjlQpZRAkFVDCjZfcCHt6bqJDmuh5ylCWx0RVnk3oumaknqTH5sqrY0fBWyULaHUIgAgxb46MxV3DbieAhxOxUxjSuljig9lMQ/Bcfoi9BTEv9aLORSndVxYOH525sUDC6u2gWxcNzBNRxPanyh3ktKinOgy3WoxPbtUM0t6RkbQnzBnFPgi9GCOEubY9UffIryz9iKRe8s/FUfEWosJJGxagp85bpUO3VywQ46lOtAWfNxKwa4JXQ+628+bpxYGXXMzp5rXH401VEyXwIdowXFaKWSMFHvMTVmGnc+P3oXV2QOiBCfgex8QtcQCbcQE/H+eoHzrkFo1KM7zVO4jVVj5s6lRiWF7zyXyfRMc97J3tzj87mYqZ7E2YjzUct9GUi4tjHLR8dVkBLjQcuHFleWvQfRNEhFR7uX7pkctOwvZXsft7sAtyldEUIN2UTeLxnEfxKYswzdi88BdbZ8hifUoSMftQvP+muRwN6+Q3DeqqRExP9QmTtcheiHh0Ot1x2i2km1bP9pbufw5zZdyWsOrh7vQae5OZWbsMv30pi7cd/CKj3coPEVaCP4Zhx4eQWhOZ1Y9MTXGyP8/iGjEyfa1T4fO/4Lea9vBoPBYDAYDAaDwWAwGAwGwz8GgF8siXCCbrSRhgAAAABJRU5ErkJggg==" alt="tarteaucitron.io" /></a>'}html+="       </div>";html+="   </div>";html+="</div>";if(tarteaucitron.parameters.orientation==="bottom"){orientation="Bottom"}if(tarteaucitron.parameters.orientation==="middle"||tarteaucitron.parameters.orientation==="popup"){modalAttrs=' role="dialog" aria-modal="true" aria-labelledby="tac_title"'}if(tarteaucitron.parameters.highPrivacy&&!tarteaucitron.parameters.AcceptAllCta){html+='<div tabindex="-1" id="tarteaucitronAlertBig" class="tarteaucitronAlertBig'+orientation+'"'+modalAttrs+">";html+='   <span id="tarteaucitronDisclaimerAlert" role="paragraph">';html+="       "+tarteaucitron.lang.alertBigPrivacy;html+="   </span>";html+='   <button type="button" id="tarteaucitronPersonalize" aria-label="'+tarteaucitron.lang.personalize+" "+tarteaucitron.lang.modalWindow+'" title="'+tarteaucitron.lang.personalize+" "+tarteaucitron.lang.modalWindow+'">';html+="       "+tarteaucitron.lang.personalize;html+="   </button>";if(tarteaucitron.parameters.privacyUrl!==""){html+='   <button role="link" type="button" id="tarteaucitronPrivacyUrl">';html+="       "+tarteaucitron.lang.privacyUrl;html+="   </button>"}html+="</div>"}else{html+='<div tabindex="-1" id="tarteaucitronAlertBig" class="tarteaucitronAlertBig'+orientation+'"'+modalAttrs+">";html+='   <span id="tarteaucitronDisclaimerAlert" role="paragraph">';if(tarteaucitron.parameters.highPrivacy){html+="       "+tarteaucitron.lang.alertBigPrivacy}else{html+="       "+tarteaucitron.lang.alertBigClick+" "+tarteaucitron.lang.alertBig}html+="   </span>";html+='   <button type="button" class="tarteaucitronCTAButton tarteaucitronAllow" id="tarteaucitronPersonalize2">';html+='       <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.acceptAll;html+="   </button>";if(tarteaucitron.parameters.DenyAllCta){if(tarteaucitron.reloadThePage){html+='   <button type="button" class="tarteaucitronCTAButton tarteaucitronDeny" id="tarteaucitronAllDenied2" aria-label="'+tarteaucitron.lang.denyAll+" ("+tarteaucitron.lang.reload+')" title="'+tarteaucitron.lang.denyAll+" ("+tarteaucitron.lang.reload+')">'}else{html+='   <button type="button" class="tarteaucitronCTAButton tarteaucitronDeny" id="tarteaucitronAllDenied2">'}html+='       <span class="tarteaucitronCross" aria-hidden="true"></span> '+tarteaucitron.lang.denyAll;html+="   </button>"}html+='   <button type="button" id="tarteaucitronCloseAlert" aria-label="'+tarteaucitron.lang.personalize+" "+tarteaucitron.lang.modalWindow+'" title="'+tarteaucitron.lang.personalize+" "+tarteaucitron.lang.modalWindow+'">';html+="       "+tarteaucitron.lang.personalize;html+="   </button>";if(tarteaucitron.parameters.privacyUrl!==""){html+='   <button type="button" id="tarteaucitronPrivacyUrl" role="link">';html+="       "+tarteaucitron.lang.privacyUrl;html+="   </button>"}html+="</div>";html+='<div id="tarteaucitronPercentage"></div>'}if(tarteaucitron.parameters.showIcon===true){html+='<div id="tarteaucitronIcon" class="tarteaucitronIcon'+tarteaucitron.parameters.iconPosition+'">';html+='   <button type="button" id="tarteaucitronManager" aria-label="'+tarteaucitron.lang.icon+" "+tarteaucitron.lang.modalWindow+'" title="'+tarteaucitron.lang.icon+" "+tarteaucitron.lang.modalWindow+'">';html+='       <img src="'+(tarteaucitron.parameters.iconSrc?tarteaucitron.parameters.iconSrc:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAGA0lEQVRoge1a207bWBRdBtJwLYZhKDMVmlSK1LxNkPo+ZH6g8B6p5AuALwC+APoFoVLeoT8whPeRSt+CZKmZVu3AiIsRlEtCktGyjy8xzuXYhvahS0JJHJ/4rLP3XnuffcAPfGdQ7mM6jRLSAF4BxqsbewB2lRS2o35mpEQaJcwCyANIdLi1DGBNSWEzqmdHRqRRwjqAJclhtExOSUEP+/xIiDRKhhUWfL7ShTtBuJnqcw+/z4Ql0xNmMEwSSz4kuNIzSgpjSsqYJP/GeE185wYJroedRyiLNEpGLLzzrHSuk+83SgbxvOcyyRaDziWsRVZkSRDinpzPbwVGWIucuohsKynMS47fAQyls/BMSRmKJo3AFhG5wm2N1wF+Zs3zebbFfR0RxrXcJHQlgH+LMW616pR/WiIMEXfW3mtzXyeEGWsjKot8c4TOI98L+iKaR5PS6IUk88RLAO9F8UjrbYoYMOosNavpfmODIiwRXRR/G3ohaWVo1RU/c30jV8ab2mV8qVGzHWBOLyTLZiWs5Rolg/C3ySOi0tXP/k4aEwOwSBKPJs7Rp16ABJTe+p1xVX0It/owqqdDEMRoqd3RFxqDPh20Ig6VEPVC0i5RSCD+6wl6HlW7GksSlUMV11/GrUs5NasFLusDE9ELSVphXemtJwaT/8JyIRvxNNCfBmIiNdR04LII3DSrbe0yjqvyJF/ppptqVlt+MCLCEh/oOkPPP6N38Mb5cnQBGFsEqmXg5j3QMwoMzwGnr4HYbybBq13gZAOom/FO63zdf2qQArCsZrUN2TlJy69eSDKYV+6Q4MpP75ivHzPA53ngaBW4eGuSOt0A/lsGPmXMz0+3TFJcTfFbPfFbfnwlhON+iQhlWmA82CQ4ocQ7c6KcfL3DHuls0yT6Sx4YnLXJDCQOIRRv5yGIJBgP8Sdisj2qubpc5UGJmo+W49ifVmzL8HcpGhQPvZCUKiCliIhEN0tr2OCqHuSA8gwQ/92MkU7gxEmeVqGrTTgpxPXbUrtGWYus0I9thRIraagRQUIDf7Qn4yZhKRiFQIyhfMfUr3yblokVWSJ6k8xSnc7eNN/RjowfCYiFoDUFer1S3gW6JiJ8Nt30EMbEhU+vzSIztuRYjRLsR8IHLjlf7HZ+MrWWEXxNmbvapt4jGSqZRYSkGUetSNTPzHsui5YMQ2ajJUNks6mw4wT54Ok2ShnzzIPCUGshzawCRKy5FqvrTZe0RWzQGvw79m67XZjKmxJrLsICjtZa55gxXy+6F4sYsEtxTqhXdRTLC8ulSDaWoCLsolfN+8YUhOsJV709H7Cudr0LlVEtzqBcN+shEyThdR941OnAbF8pirKJqXyupTRTtQSReiVmXW1j7oBErB0d9xM2WEd5J9ZKYtuR4WKwwBSoORbpGrJ5ZI9lt71irJmGX1px0JYE26uNErawr2zfIcP4OHEKXm66PA3wjpCNEfpJunI4muifPjKvsFCkGjExTq63yxMJsZNMYF/J4HmDC5A3Yq36jy0ClePHVhwuu/b1HSFlEfHD5ZtD1bEK44Qu1mWys6tbWmZyPWckzlPTGiRw/XHCuk+q4Rek+mVrVL/UppwrdDEGNV2kpyuhccgc5Oxm9vWnn+19vJrVpLor0kTUrGacMplb1CfOFyTD4o9uNrHqr2Z+ZMSp1c2XcVSORnh9Q81q3k599ETgkNnjg0nGzi10K7rX+bZpHbrblPcY5A4Zxk2xcjzCvTpd9027Aa0QtouyyrKFRR6D/04DwkFGvHPXM3Qda/Jb4nPgI7hQLVM1q5HIBt2MzQNa57Z1DiiLAGa5Mi+O4Sz3Mpp6laPHO6InII3ITnX1QtI+EOX+m9ZxleOZ/j9PiuKoLi3aqXPuEoSye/Vhkm+LalbLtHhMS0R6zu7aZ3vP2jOjL7QVv4McxhcDnZIelAQibGIbULOapf3PuE1Vs9qeaOTdkVKr00gCQiw4NlBzDvf1Lxx+uP5r3Dgv5KQZRzWn+GRwz8jmDS8itUg7iB6vLuJCF5Uty4A9mVKkFR6MiJDachST/oHvHgD+B4SoUIitpF05AAAAAElFTkSuQmCC")+'" alt="'+tarteaucitron.lang.icon+" "+tarteaucitron.lang.modalWindow+'" title="'+tarteaucitron.lang.icon+" "+tarteaucitron.lang.modalWindow+'">';html+="   </button>";html+="</div>"}if(tarteaucitron.parameters.showAlertSmall===true){html+='<div id="tarteaucitronAlertSmall" class="tarteaucitronAlertSmall'+orientation+'">';html+='   <button type="button" id="tarteaucitronManager" aria-label="'+tarteaucitron.lang.alertSmall+" "+tarteaucitron.lang.modalWindow+'" title="'+tarteaucitron.lang.alertSmall+" "+tarteaucitron.lang.modalWindow+'">';html+="       "+tarteaucitron.lang.alertSmall;html+='       <span id="tarteaucitronDot">';html+='           <span id="tarteaucitronDotGreen"></span>';html+='           <span id="tarteaucitronDotYellow"></span>';html+='           <span id="tarteaucitronDotRed"></span>';html+="       </span>";if(tarteaucitron.parameters.cookieslist===true){html+="   </button>\x3c!-- @whitespace";html+='   --\x3e<button type="button" id="tarteaucitronCookiesNumber" aria-expanded="false" aria-controls="tarteaucitronCookiesListContainer">0</button>';html+='   <div id="tarteaucitronCookiesListContainer">';if(tarteaucitron.reloadThePage){html+='       <button type="button" id="tarteaucitronClosePanelCookie" aria-label="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')" title="'+tarteaucitron.lang.close+" ("+tarteaucitron.lang.reload+')">'}else{html+='       <button type="button" id="tarteaucitronClosePanelCookie">'}html+="           "+tarteaucitron.lang.close;html+="       </button>";html+='       <div class="tarteaucitronCookiesListMain" id="tarteaucitronCookiesTitle">';html+='            <span class="tarteaucitronH2" role="heading" aria-level="2" id="tarteaucitronCookiesNumberBis">0 cookie</span>';html+="       </div>";html+='       <div id="tarteaucitronCookiesList"></div>';html+="    </div>"}else{html+="   </div>"}html+="</div>"}tarteaucitron.addInternalScript(tarteaucitron.cdn+"advertising"+(useMinifiedJS?".min":"")+".js","",function(){if(tarteaucitronNoAdBlocker===true||tarteaucitron.parameters.adblocker===false){div.id="tarteaucitronRoot";if(tarteaucitron.parameters.bodyPosition==="top"){var bodyFirstChild=body.firstChild;body.insertBefore(div,bodyFirstChild)}else{body.appendChild(div,body)}div.setAttribute("data-nosnippet","true");div.setAttribute("lang",language);div.setAttribute("role","region");div.setAttribute("aria-labelledby","tac_title");div.innerHTML=html;var tacRootAvailableEvent;if(typeof Event==="function"){tacRootAvailableEvent=new Event("tac.root_available")}else if(typeof document.createEvent==="function"){tacRootAvailableEvent=document.createEvent("Event");tacRootAvailableEvent.initEvent("tac.root_available",true,true)}if(typeof window.dispatchEvent==="function"){window.dispatchEvent(tacRootAvailableEvent)}if(tarteaucitron.job!==undefined){tarteaucitron.job=tarteaucitron.cleanArray(tarteaucitron.job);for(index=0;index<tarteaucitron.job.length;index+=1){tarteaucitron.addService(tarteaucitron.job[index])}}else{tarteaucitron.job=[]}if(tarteaucitron.job.length===0){tarteaucitron.userInterface.closeAlert()}tarteaucitron.isAjax=true;tarteaucitron.job.push=function(id){if(typeof tarteaucitron.job.indexOf==="undefined"){tarteaucitron.job.indexOf=function(obj,start){var i,j=this.length;for(i=start||0;i<j;i+=1){if(this[i]===obj){return i}}return-1}}if(tarteaucitron.job.indexOf(id)===-1){Array.prototype.push.call(this,id)}tarteaucitron.launch[id]=false;tarteaucitron.addService(id)};if(document.location.hash===tarteaucitron.hashtag&&tarteaucitron.hashtag!==""){tarteaucitron.userInterface.openPanel()}tarteaucitron.cookie.number();setInterval(tarteaucitron.cookie.number,6e4)}},tarteaucitron.parameters.adblocker);if(tarteaucitron.parameters.adblocker===true){setTimeout(function(){if(tarteaucitronNoAdBlocker===false){html='<div id="tarteaucitronAlertBig" class="tarteaucitronAlertBig'+orientation+' tarteaucitron-display-block" role="alert" aria-live="polite">';html+='   <p id="tarteaucitronDisclaimerAlert">';html+="       "+tarteaucitron.lang.adblock+"<br/>";html+="       <strong>"+tarteaucitron.lang.adblock_call+"</strong>";html+="   </p>";html+='   <button type="button" class="tarteaucitronCTAButton" id="tarteaucitronCTAButton">';html+="       "+tarteaucitron.lang.reload;html+="   </button>";html+="</div>";html+='<div role="heading" aria-level="1" id="tac_title" class="tac_visually-hidden">'+tarteaucitron.lang.title+"</div>";html+='<div id="tarteaucitronPremium"></div>';div.id="tarteaucitronRoot";if(tarteaucitron.parameters.bodyPosition==="top"){var bodyFirstChild=body.firstChild;body.insertBefore(div,bodyFirstChild)}else{body.appendChild(div,body)}div.setAttribute("data-nosnippet","true");div.setAttribute("lang",language);div.setAttribute("role","region");div.setAttribute("aria-labelledby","tac_title");div.innerHTML=html}},1500)}if(tarteaucitron.parameters.closePopup===true){setTimeout(function(){var closeElement=document.getElementById("tarteaucitronAlertBig"),closeButton=document.createElement("button");if(closeElement){closeButton.innerHTML='<span aria-hidden="true">X</span><span class="tac_visually-hidden">'+tarteaucitron.lang.closeBanner+"</span>";closeButton.setAttribute("id","tarteaucitronCloseCross");closeElement.insertAdjacentElement("beforeend",closeButton)}},100)}if(tarteaucitron.parameters.groupServices===true){var tac_group_style=document.createElement("style");tac_group_style.innerHTML=".tarteaucitronTitle{display:none}";document.head.appendChild(tac_group_style);var cats=document.querySelectorAll('[id^="tarteaucitronServicesTitle_"]');Array.prototype.forEach.call(cats,function(item){var cat=item.getAttribute("id").replace(/^(tarteaucitronServicesTitle_)/,"");if(cat!=="mandatory"){var html="";html+='<li  class="tarteaucitronLine">';html+='   <div class="tarteaucitronName">';html+='       <span class="tarteaucitronH3" role="heading" aria-level="2">'+tarteaucitron.lang[cat].title+"</span>";html+="       <span>"+tarteaucitron.lang[cat].details+"</span>";html+='   <button type="button" aria-expanded="false" class="tarteaucitron-toggle-group" id="tarteaucitron-toggle-group-'+cat+'">'+tarteaucitron.lang.alertSmall+" ("+document.getElementById("tarteaucitronServices_"+cat).childElementCount+")</button>";html+="   </div>";html+='   <div class="tarteaucitronAsk" id="tarteaucitron-group-'+cat+'">';html+='       <button type="button" aria-label="'+tarteaucitron.lang.allow+" "+tarteaucitron.lang[cat].title+'" class="tarteaucitronAllow" id="tarteaucitron-accept-group-'+cat+'">';html+='           <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.allow;html+="       </button> ";html+='       <button type="button" aria-label="'+tarteaucitron.lang.deny+" "+tarteaucitron.lang[cat].title+'" class="tarteaucitronDeny" id="tarteaucitron-reject-group-'+cat+'">';html+='           <span class="tarteaucitronCross" aria-hidden="true"></span> '+tarteaucitron.lang.deny;html+="       </button>";html+="   </div>";html+="</li>";var ul=document.createElement("ul");ul.innerHTML=html;item.insertBefore(ul,item.querySelector("#tarteaucitronServices_"+cat+""));document.querySelector("#tarteaucitronServices_"+cat).style.display="none";tarteaucitron.addClickEventToId("tarteaucitron-toggle-group-"+cat,function(){tarteaucitron.userInterface.toggle("tarteaucitronServices_"+cat);if(document.getElementById("tarteaucitronServices_"+cat).style.display=="block"){tarteaucitron.userInterface.addClass("tarteaucitronServicesTitle_"+cat,"tarteaucitronIsExpanded");document.getElementById("tarteaucitron-toggle-group-"+cat).setAttribute("aria-expanded","true")}else{tarteaucitron.userInterface.removeClass("tarteaucitronServicesTitle_"+cat,"tarteaucitronIsExpanded");document.getElementById("tarteaucitron-toggle-group-"+cat).setAttribute("aria-expanded","false")}});tarteaucitron.addClickEventToId("tarteaucitron-accept-group-"+cat,function(){tarteaucitron.userInterface.respondAll(true,cat)});tarteaucitron.addClickEventToId("tarteaucitron-reject-group-"+cat,function(){tarteaucitron.userInterface.respondAll(false,cat)})}})}if(tarteaucitron.parameters.partnersList===true&&(tarteaucitron.parameters.orientation==="middle"||tarteaucitron.parameters.orientation==="popup")){setTimeout(function(){var liPartners="";var tarteaucitronPartnersCat=[];tarteaucitron.job.forEach(function(id){if(tarteaucitronPartnersCat[tarteaucitron.services[id].type]===undefined){tarteaucitronPartnersCat[tarteaucitron.services[id].type]=true;liPartners+="<li>"+tarteaucitron.lang[tarteaucitron.services[id].type].title+"</li>"}});var tacPartnersInfoParent=document.getElementById("tarteaucitronDisclaimerAlert");if(tacPartnersInfoParent!==null){tacPartnersInfoParent.insertAdjacentHTML("beforeend",'<div class="tarteaucitronPartnersList"><b>'+tarteaucitron.lang.ourpartners+" ("+tarteaucitron.job.length+")</b> <ul>"+liPartners+"</ul></div>")}},100)}setTimeout(function(){var tacSaveButtonParent=document.getElementById("tarteaucitronServices");if(tacSaveButtonParent!==null){tacSaveButtonParent.insertAdjacentHTML("beforeend",'<div id="tarteaucitronSave"><button class="tarteaucitronAllow" id="tarteaucitronSaveButton">'+tarteaucitron.lang.save+"</button></div>")}},100);tarteaucitron.userInterface.color("",true);setTimeout(function(){tarteaucitron.addClickEventToId("tarteaucitronCloseCross",function(){tarteaucitron.userInterface.closeAlert()});tarteaucitron.addClickEventToId("tarteaucitronPersonalize",function(){tarteaucitron.userInterface.openPanel()});tarteaucitron.addClickEventToId("tarteaucitronPersonalize2",function(){tarteaucitron.userInterface.respondAll(true)});tarteaucitron.addClickEventToId("tarteaucitronManager",function(){tarteaucitron.userInterface.openPanel()});tarteaucitron.addClickEventToId("tarteaucitronBack",function(){tarteaucitron.userInterface.closePanel()});tarteaucitron.addClickEventToId("tarteaucitronClosePanel",function(){tarteaucitron.userInterface.closePanel()});tarteaucitron.addClickEventToId("tarteaucitronClosePanelCookie",function(){tarteaucitron.userInterface.closePanel()});tarteaucitron.addClickEventToId("tarteaucitronPrivacyUrl",function(){document.location=tarteaucitron.parameters.privacyUrl});tarteaucitron.addClickEventToId("tarteaucitronPrivacyUrlDialog",function(){document.location=tarteaucitron.parameters.privacyUrl});tarteaucitron.addClickEventToId("tarteaucitronCookiesNumber",function(){tarteaucitron.userInterface.toggleCookiesList()});tarteaucitron.addClickEventToId("tarteaucitronAllAllowed",function(){tarteaucitron.userInterface.respondAll(true)});tarteaucitron.addClickEventToId("tarteaucitronAllDenied",function(){tarteaucitron.userInterface.respondAll(false)});tarteaucitron.addClickEventToId("tarteaucitronAllDenied2",function(){tarteaucitron.userInterface.respondAll(false,"",true);if(tarteaucitron.reloadThePage===true){window.location.reload()}});tarteaucitron.addClickEventToId("tarteaucitronCloseAlert",function(){tarteaucitron.userInterface.openPanel()});tarteaucitron.addClickEventToId("tarteaucitronCTAButton",function(){location.reload()});tarteaucitron.addClickEventToId("tarteaucitronSaveButton",function(){var timeoutSaveButton=0;tarteaucitron.job.forEach(function(id){if(tarteaucitron.state[id]!==true&&tarteaucitron.state[id]!==false){timeoutSaveButton=500;tarteaucitron.setConsent(id,false)}});setTimeout(tarteaucitron.userInterface.closePanel,timeoutSaveButton)});var toggleBtns=document.getElementsByClassName("catToggleBtn"),i;for(i=0;i<toggleBtns.length;i++){toggleBtns[i].dataset.index=i;tarteaucitron.addClickEventToElement(toggleBtns[i],function(){if(!tarteaucitron.parameters.showDetailsOnClick)return false;tarteaucitron.userInterface.toggle("tarteaucitronDetails"+cat[this.dataset.index],"tarteaucitronInfoBox");if(document.getElementById("tarteaucitronDetails"+cat[this.dataset.index]).style.display==="block"){this.setAttribute("aria-expanded","true")}else{this.setAttribute("aria-expanded","false")}return false})}var allowBtnsInSite=document.querySelectorAll(".tac_activate .tarteaucitronAllow");for(i=0;i<allowBtnsInSite.length;i++){tarteaucitron.addClickEventToElement(allowBtnsInSite[i],function(){if(this.closest(".tac_activate")!==null&&this.closest(".tac_activate").parentNode!==null){this.closest(".tac_activate").parentNode.setAttribute("tabindex","-1");this.closest(".tac_activate").parentNode.focus()}})}var allowBtns=document.getElementsByClassName("tarteaucitronAllow");for(i=0;i<allowBtns.length;i++){tarteaucitron.addClickEventToElement(allowBtns[i],function(){tarteaucitron.userInterface.respond(this,true)})}var denyBtns=document.getElementsByClassName("tarteaucitronDeny");for(i=0;i<denyBtns.length;i++){tarteaucitron.addClickEventToElement(denyBtns[i],function(){tarteaucitron.userInterface.respond(this,false)})}if(tarteaucitron.events.load){tarteaucitron.events.load()}},500)})})},addService:function(serviceId){"use strict";var html="",s=tarteaucitron.services,service=s[serviceId];if(tarteaucitron.parameters.alwaysNeedConsent===true){service.needConsent=true}var cookie=tarteaucitron.cookie.read(),hostname=document.location.hostname,hostRef=document.referrer.split("/")[2],isNavigating=hostRef===hostname&&window.location.href!==tarteaucitron.parameters.privacyUrl,isAutostart=!service.needConsent,isWaiting=cookie.indexOf(service.key+"=wait")>=0,isDenied=cookie.indexOf(service.key+"=false")>=0,isAllowed=cookie.indexOf(service.key+"=true")>=0||!service.needConsent&&cookie.indexOf(service.key+"=false")<0,isResponded=cookie.indexOf(service.key+"=false")>=0||cookie.indexOf(service.key+"=true")>=0,isDNTRequested=navigator.doNotTrack==="1"||navigator.doNotTrack==="yes"||navigator.msDoNotTrack==="1"||window.doNotTrack==="1",currentStatus=isAllowed?tarteaucitron.lang.allowed:tarteaucitron.lang.disallowed,state=undefined!==service.defaultState?service.defaultState:undefined!==tarteaucitron.parameters.serviceDefaultState?tarteaucitron.parameters.serviceDefaultState:"wait";if(tarteaucitron.added[service.key]!==true){tarteaucitron.added[service.key]=true;html+='<li id="'+service.key+'Line" class="tarteaucitronLine">';html+='   <div class="tarteaucitronName">';html+='       <span class="tarteaucitronH3" role="heading" aria-level="3">'+service.name+"</span>";html+='       <div class="tarteaucitronStatusInfo">';html+='          <span class="tacCurrentStatus" id="tacCurrentStatus'+service.key+'">'+currentStatus+"</span>";html+='          <span class="tarteaucitronReadmoreSeparator"> - </span>';html+='          <span id="tacCL'+service.key+'" class="tarteaucitronListCookies"></span>';html+="       </div>";if(tarteaucitron.parameters.moreInfoLink==true){var link="https://tarteaucitron.io/service/"+service.key+"/";if(service.readmoreLink!==undefined&&service.readmoreLink!==""){link=service.readmoreLink}if(tarteaucitron.parameters.readmoreLink!==undefined&&tarteaucitron.parameters.readmoreLink!==""){link=tarteaucitron.parameters.readmoreLink}html+='       <a href="'+link+'" target="_blank" rel="noreferrer noopener nofollow" title="'+tarteaucitron.lang.more+" : "+tarteaucitron.lang.cookieDetail+" "+service.name+" "+tarteaucitron.lang.ourSite+" "+tarteaucitron.lang.newWindow+'" class="tarteaucitronReadmoreInfo">'+tarteaucitron.lang.more+"</a>";html+='       <span class="tarteaucitronReadmoreSeparator"> - </span>';html+='       <a href="'+service.uri+'" target="_blank" rel="noreferrer noopener" title="'+tarteaucitron.lang.source+" "+service.name+" "+tarteaucitron.lang.newWindow+'" class="tarteaucitronReadmoreOfficial">'+tarteaucitron.lang.source+"</a>"}html+="   </div>";html+='   <div class="tarteaucitronAsk">';html+='       <button type="button" aria-label="'+tarteaucitron.lang.allow+" "+service.name+'" id="'+service.key+'Allowed" class="tarteaucitronAllow">';html+='           <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.allow;html+="       </button> ";html+='       <button type="button" aria-label="'+tarteaucitron.lang.deny+" "+service.name+'" id="'+service.key+'Denied" class="tarteaucitronDeny">';html+='           <span class="tarteaucitronCross" aria-hidden="true"></span> '+tarteaucitron.lang.deny;html+="       </button>";html+="   </div>";html+="</li>";tarteaucitron.userInterface.css("tarteaucitronServicesTitle_"+service.type,"display","block");if(document.getElementById("tarteaucitronServices_"+service.type)!==null){document.getElementById("tarteaucitronServices_"+service.type).innerHTML+=html}tarteaucitron.userInterface.css("tarteaucitronNoServicesTitle","display","none");tarteaucitron.userInterface.order(service.type);tarteaucitron.addClickEventToId(service.key+"Allowed",function(){tarteaucitron.userInterface.respond(this,true)});tarteaucitron.addClickEventToId(service.key+"Denied",function(){tarteaucitron.userInterface.respond(this,false)})}tarteaucitron.pro("!"+service.key+"="+isAllowed);if(isResponded===false&&tarteaucitron.user.bypass===true){isAllowed=true;tarteaucitron.cookie.create(service.key,true)}if(!isResponded&&(isAutostart||isNavigating&&isWaiting)&&!tarteaucitron.highPrivacy||isAllowed){if(!isAllowed||!service.needConsent&&cookie.indexOf(service.key+"=false")<0){tarteaucitron.cookie.create(service.key,true)}if(tarteaucitron.launch[service.key]!==true){tarteaucitron.launch[service.key]=true;if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+service.key+"_")<0){service.js()}tarteaucitron.sendEvent(service.key+"_loaded")}tarteaucitron.state[service.key]=true;tarteaucitron.userInterface.color(service.key,true)}else if(isDenied){if(typeof service.fallback==="function"){if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+service.key+"_")<0){service.fallback()}}tarteaucitron.state[service.key]=false;tarteaucitron.userInterface.color(service.key,false)}else if(!isResponded&&isDNTRequested&&tarteaucitron.handleBrowserDNTRequest){tarteaucitron.cookie.create(service.key,"false");if(typeof service.fallback==="function"){if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+service.key+"_")<0){service.fallback()}}tarteaucitron.state[service.key]=false;tarteaucitron.userInterface.color(service.key,false)}else if(!isResponded){tarteaucitron.cookie.create(service.key,state);if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+service.key+"_")<0){if(true===state&&typeof service.js==="function"){service.js();tarteaucitron.sendEvent(key+"_loaded")}else if(typeof service.fallback==="function"){service.fallback()}}tarteaucitron.userInterface.color(service.key,state);if("wait"===state){tarteaucitron.userInterface.openAlert()}}tarteaucitron.cookie.checkCount(service.key);tarteaucitron.sendEvent(service.key+"_added")},sendEvent:function(event_key){if(event_key!==undefined){var send_event_item;if(typeof Event==="function"){send_event_item=new Event(event_key)}else if(typeof document.createEvent==="function"){send_event_item=document.createEvent("Event");send_event_item.initEvent(event_key,true,true)}document.dispatchEvent(send_event_item)}},cleanArray:function cleanArray(arr){"use strict";var i,len=arr.length,out=[],obj={},s=tarteaucitron.services;for(i=0;i<len;i+=1){if(!obj[arr[i]]){obj[arr[i]]={};if(tarteaucitron.services[arr[i]]!==undefined){out.push(arr[i])}}}out=out.sort(function(a,b){if(s[a].type+s[a].key>s[b].type+s[b].key){return 1}if(s[a].type+s[a].key<s[b].type+s[b].key){return-1}return 0});return out},setConsent:function(id,status){if(status===true){tarteaucitron.userInterface.respond(document.getElementById(id+"Allowed"),true)}else if(status===false){tarteaucitron.userInterface.respond(document.getElementById(id+"Denied"),false)}},userInterface:{css:function(id,property,value){"use strict";if(document.getElementById(id)!==null){if(property=="display"&&value=="none"&&(id=="tarteaucitron"||id=="tarteaucitronBack"||id=="tarteaucitronAlertBig")){document.getElementById(id).style["opacity"]="0";document.getElementById(id).style[property]=value}else{document.getElementById(id).style[property]=value;if(property=="display"&&value=="block"&&(id=="tarteaucitron"||id=="tarteaucitronAlertBig")){document.getElementById(id).style["opacity"]="1"}if(property=="display"&&value=="block"&&id=="tarteaucitronBack"){document.getElementById(id).style["opacity"]="0.7"}if(property=="display"&&value=="block"&&id=="tarteaucitronAlertBig"&&(tarteaucitron.parameters.orientation=="middle"||tarteaucitron.parameters.orientation=="popup")){tarteaucitron.userInterface.focusTrap("tarteaucitronAlertBig")}}}},addClass:function(id,className){"use strict";if(document.getElementById(id)!==null&&document.getElementById(id).classList!==undefined){document.getElementById(id).classList.add(className)}},removeClass:function(id,className){"use strict";if(document.getElementById(id)!==null&&document.getElementById(id).classList!==undefined){document.getElementById(id).classList.remove(className)}},respondAll:function(status,type,allowSafeAnalytics){"use strict";var s=tarteaucitron.services,service,key,index=0;for(index=0;index<tarteaucitron.job.length;index+=1){if(typeof type!=="undefined"&&type!==""&&s[tarteaucitron.job[index]].type!==type){continue}if(allowSafeAnalytics&&typeof s[tarteaucitron.job[index]].safeanalytic!=="undefined"&&s[tarteaucitron.job[index]].safeanalytic===true){continue}service=s[tarteaucitron.job[index]];key=service.key;if(tarteaucitron.state[key]!==status){if(status===false&&tarteaucitron.launch[key]===true){tarteaucitron.reloadThePage=true;if(tarteaucitron.checkIfExist("tarteaucitronClosePanel")){var ariaCloseValue=document.getElementById("tarteaucitronClosePanel").textContent.trim()+" ("+tarteaucitron.lang.reload+")";document.getElementById("tarteaucitronClosePanel").setAttribute("aria-label",ariaCloseValue);document.getElementById("tarteaucitronClosePanel").setAttribute("title",ariaCloseValue)}}if(tarteaucitron.launch[key]!==true&&status===true){tarteaucitron.pro("!"+key+"=engage");tarteaucitron.launch[key]=true;if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+key+"_")<0){tarteaucitron.services[key].js()}tarteaucitron.sendEvent(key+"_loaded")}var itemStatusElem=document.getElementById("tacCurrentStatus"+key);tarteaucitron.state[key]=status;tarteaucitron.cookie.create(key,status);tarteaucitron.userInterface.color(key,status);if(status==true){itemStatusElem.innerHTML=tarteaucitron.lang.allowed;tarteaucitron.sendEvent(key+"_allowed")}else{itemStatusElem.innerHTML=tarteaucitron.lang.disallowed;tarteaucitron.sendEvent(key+"_disallowed")}}}},respond:function(el,status){"use strict";if(el.id===""){return}var key=el.id.replace(new RegExp("(Eng[0-9]+|Allow|Deni)ed","g"),"");if(key.substring(0,13)==="tarteaucitron"||key===""){return}if(tarteaucitron.state[key]===status){return}if(status===false&&tarteaucitron.launch[key]===true){tarteaucitron.reloadThePage=true;if(tarteaucitron.checkIfExist("tarteaucitronClosePanel")){var ariaCloseValue=document.getElementById("tarteaucitronClosePanel").textContent.trim()+" ("+tarteaucitron.lang.reload+")";document.getElementById("tarteaucitronClosePanel").setAttribute("aria-label",ariaCloseValue);document.getElementById("tarteaucitronClosePanel").setAttribute("title",ariaCloseValue)}}if(status===true){if(tarteaucitron.launch[key]!==true){tarteaucitron.pro("!"+key+"=engage");tarteaucitron.launch[key]=true;if(typeof tarteaucitronMagic==="undefined"||tarteaucitronMagic.indexOf("_"+key+"_")<0){tarteaucitron.services[key].js()}tarteaucitron.sendEvent(key+"_loaded")}}var itemStatusElem=document.getElementById("tacCurrentStatus"+key);tarteaucitron.state[key]=status;tarteaucitron.cookie.create(key,status);tarteaucitron.userInterface.color(key,status);if(status==true){itemStatusElem.innerHTML=tarteaucitron.lang.allowed;tarteaucitron.sendEvent(key+"_allowed")}else{itemStatusElem.innerHTML=tarteaucitron.lang.disallowed;tarteaucitron.sendEvent(key+"_disallowed")}},color:function(key,status){"use strict";var c="tarteaucitron",nbDenied=0,nbPending=0,nbAllowed=0,sum=tarteaucitron.job.length,index,s=tarteaucitron.services;if(key!==""){if(status===true){tarteaucitron.userInterface.addClass(key+"Line","tarteaucitronIsAllowed");tarteaucitron.userInterface.removeClass(key+"Line","tarteaucitronIsDenied");document.getElementById(key+"Allowed").setAttribute("aria-pressed","true");document.getElementById(key+"Denied").setAttribute("aria-pressed","false")}else if(status===false){tarteaucitron.userInterface.removeClass(key+"Line","tarteaucitronIsAllowed");tarteaucitron.userInterface.addClass(key+"Line","tarteaucitronIsDenied");document.getElementById(key+"Allowed").setAttribute("aria-pressed","false");document.getElementById(key+"Denied").setAttribute("aria-pressed","true")}else{document.getElementById(key+"Allowed").setAttribute("aria-pressed","false");document.getElementById(key+"Denied").setAttribute("aria-pressed","false")}var sumToRemove=0;for(index=0;index<sum;index+=1){if(typeof s[tarteaucitron.job[index]].safeanalytic!=="undefined"&&s[tarteaucitron.job[index]].safeanalytic===true){sumToRemove+=1;continue}if(tarteaucitron.state[tarteaucitron.job[index]]===false){nbDenied+=1}else if(tarteaucitron.state[tarteaucitron.job[index]]===undefined){nbPending+=1}else if(tarteaucitron.state[tarteaucitron.job[index]]===true){nbAllowed+=1}}sum-=sumToRemove;tarteaucitron.userInterface.css(c+"DotGreen","width",100/sum*nbAllowed+"%");tarteaucitron.userInterface.css(c+"DotYellow","width",100/sum*nbPending+"%");tarteaucitron.userInterface.css(c+"DotRed","width",100/sum*nbDenied+"%");if(nbDenied===0&&nbPending===0){tarteaucitron.userInterface.removeClass(c+"AllDenied",c+"IsSelected");tarteaucitron.userInterface.addClass(c+"AllAllowed",c+"IsSelected");tarteaucitron.userInterface.addClass(c+"MainLineOffset",c+"IsAllowed");tarteaucitron.userInterface.removeClass(c+"MainLineOffset",c+"IsDenied");document.getElementById(c+"AllDenied").setAttribute("aria-pressed","false");document.getElementById(c+"AllAllowed").setAttribute("aria-pressed","true")}else if(nbAllowed===0&&nbPending===0){tarteaucitron.userInterface.removeClass(c+"AllAllowed",c+"IsSelected");tarteaucitron.userInterface.addClass(c+"AllDenied",c+"IsSelected");tarteaucitron.userInterface.removeClass(c+"MainLineOffset",c+"IsAllowed");tarteaucitron.userInterface.addClass(c+"MainLineOffset",c+"IsDenied");document.getElementById(c+"AllDenied").setAttribute("aria-pressed","true");document.getElementById(c+"AllAllowed").setAttribute("aria-pressed","false")}else{tarteaucitron.userInterface.removeClass(c+"AllAllowed",c+"IsSelected");tarteaucitron.userInterface.removeClass(c+"AllDenied",c+"IsSelected");tarteaucitron.userInterface.removeClass(c+"MainLineOffset",c+"IsAllowed");tarteaucitron.userInterface.removeClass(c+"MainLineOffset",c+"IsDenied");document.getElementById(c+"AllDenied").setAttribute("aria-pressed","false");document.getElementById(c+"AllAllowed").setAttribute("aria-pressed","false")}if(nbPending===0){tarteaucitron.userInterface.closeAlert()}if(tarteaucitron.services[key].cookies.length>0&&status===false){tarteaucitron.cookie.purge(tarteaucitron.services[key].cookies)}if(status===true){if(document.getElementById("tacCL"+key)!==null){document.getElementById("tacCL"+key).innerHTML="..."}setTimeout(function(){tarteaucitron.cookie.checkCount(key)},2500)}else{tarteaucitron.cookie.checkCount(key)}}var cats=document.querySelectorAll('[id^="tarteaucitronServicesTitle_"]');Array.prototype.forEach.call(cats,function(item){var cat=item.getAttribute("id").replace(/^(tarteaucitronServicesTitle_)/,""),total=document.getElementById("tarteaucitronServices_"+cat).childElementCount;var doc=document.getElementById("tarteaucitronServices_"+cat),groupdenied=0,groupallowed=0;for(var ii=0;ii<doc.children.length;ii++){if(doc.children[ii].className=="tarteaucitronLine tarteaucitronIsDenied"){groupdenied++}if(doc.children[ii].className=="tarteaucitronLine tarteaucitronIsAllowed"){groupallowed++}}if(total===groupallowed){tarteaucitron.userInterface.removeClass("tarteaucitron-group-"+cat,"tarteaucitronIsDenied");tarteaucitron.userInterface.addClass("tarteaucitron-group-"+cat,"tarteaucitronIsAllowed");if(document.getElementById("tarteaucitron-reject-group-"+cat)){document.getElementById("tarteaucitron-reject-group-"+cat).setAttribute("aria-pressed","false");document.getElementById("tarteaucitron-accept-group-"+cat).setAttribute("aria-pressed","true")}}if(total===groupdenied){tarteaucitron.userInterface.addClass("tarteaucitron-group-"+cat,"tarteaucitronIsDenied");tarteaucitron.userInterface.removeClass("tarteaucitron-group-"+cat,"tarteaucitronIsAllowed");if(document.getElementById("tarteaucitron-reject-group-"+cat)){document.getElementById("tarteaucitron-reject-group-"+cat).setAttribute("aria-pressed","true");document.getElementById("tarteaucitron-accept-group-"+cat).setAttribute("aria-pressed","false")}}if(total!==groupdenied&&total!==groupallowed){tarteaucitron.userInterface.removeClass("tarteaucitron-group-"+cat,"tarteaucitronIsDenied");tarteaucitron.userInterface.removeClass("tarteaucitron-group-"+cat,"tarteaucitronIsAllowed");if(document.getElementById("tarteaucitron-reject-group-"+cat)){document.getElementById("tarteaucitron-reject-group-"+cat).setAttribute("aria-pressed","false");document.getElementById("tarteaucitron-accept-group-"+cat).setAttribute("aria-pressed","false")}}groupdenied=0;groupallowed=0})},openPanel:function(){"use strict";tarteaucitron.userInterface.css("tarteaucitron","display","block");tarteaucitron.userInterface.css("tarteaucitronBack","display","block");tarteaucitron.userInterface.css("tarteaucitronCookiesListContainer","display","none");document.getElementById("tarteaucitronClosePanel").focus();if(document.getElementsByTagName("body")[0].classList!==undefined){document.getElementsByTagName("body")[0].classList.add("tarteaucitron-modal-open")}tarteaucitron.userInterface.focusTrap("tarteaucitron");tarteaucitron.userInterface.jsSizing("main");var tacOpenPanelEvent;if(typeof Event==="function"){tacOpenPanelEvent=new Event("tac.open_panel")}else if(typeof document.createEvent==="function"){tacOpenPanelEvent=document.createEvent("Event");tacOpenPanelEvent.initEvent("tac.open_panel",true,true)}if(typeof window.dispatchEvent==="function"){window.dispatchEvent(tacOpenPanelEvent)}},closePanel:function(){"use strict";if(document.location.hash===tarteaucitron.hashtag){if(window.history){window.history.replaceState("",document.title,window.location.pathname+window.location.search)}else{document.location.hash=""}}if(tarteaucitron.checkIfExist("tarteaucitron")){if(tarteaucitron.checkIfExist("tarteaucitronCloseAlert")){document.getElementById("tarteaucitronCloseAlert").focus()}else if(tarteaucitron.checkIfExist("tarteaucitronManager")){document.getElementById("tarteaucitronManager").focus()}else if(tarteaucitron.customCloserId&&tarteaucitron.checkIfExist(tarteaucitron.customCloserId)){document.getElementById(tarteaucitron.customCloserId).focus()}tarteaucitron.userInterface.css("tarteaucitron","display","none")}if(tarteaucitron.checkIfExist("tarteaucitronCookiesListContainer")&&tarteaucitron.checkIfExist("tarteaucitronCookiesNumber")){document.getElementById("tarteaucitronCookiesNumber").focus();document.getElementById("tarteaucitronCookiesNumber").setAttribute("aria-expanded","false");tarteaucitron.userInterface.css("tarteaucitronCookiesListContainer","display","none")}tarteaucitron.fallback(["tarteaucitronInfoBox"],function(elem){elem.style.display="none"},true);if(tarteaucitron.reloadThePage===true){window.location.reload()}else{tarteaucitron.userInterface.css("tarteaucitronBack","display","none")}if(document.getElementsByTagName("body")[0].classList!==undefined){document.getElementsByTagName("body")[0].classList.remove("tarteaucitron-modal-open")}var tacClosePanelEvent;if(typeof Event==="function"){tacClosePanelEvent=new Event("tac.close_panel")}else if(typeof document.createEvent==="function"){tacClosePanelEvent=document.createEvent("Event");tacClosePanelEvent.initEvent("tac.close_panel",true,true)}if(typeof window.dispatchEvent==="function"){window.dispatchEvent(tacClosePanelEvent)}},focusTrap:function(parentElement){"use strict";var focusableEls,firstFocusableEl,lastFocusableEl,filtered;focusableEls=document.getElementById(parentElement).querySelectorAll("a[href], button");filtered=[];for(var i=0,max=focusableEls.length;i<max;i++){if(focusableEls[i].offsetHeight>0){filtered.push(focusableEls[i])}}firstFocusableEl=filtered[0];lastFocusableEl=filtered[filtered.length-1];document.getElementById(parentElement).addEventListener("keydown",function(evt){if(evt.key==="Tab"||evt.keyCode===9){if(evt.shiftKey){if(document.activeElement===firstFocusableEl){lastFocusableEl.focus();evt.preventDefault()}}else{if(document.activeElement===lastFocusableEl){firstFocusableEl.focus();evt.preventDefault()}}}})},openAlert:function(){"use strict";var c="tarteaucitron";tarteaucitron.userInterface.css(c+"Percentage","display","block");tarteaucitron.userInterface.css(c+"AlertSmall","display","none");tarteaucitron.userInterface.css(c+"Icon","display","none");tarteaucitron.userInterface.css(c+"AlertBig","display","block");tarteaucitron.userInterface.addClass(c+"Root","tarteaucitronBeforeVisible");var tacOpenAlertEvent;if(typeof Event==="function"){tacOpenAlertEvent=new Event("tac.open_alert")}else if(typeof document.createEvent==="function"){tacOpenAlertEvent=document.createEvent("Event");tacOpenAlertEvent.initEvent("tac.open_alert",true,true)}if(document.getElementById("tarteaucitronAlertBig")!==null&&tarteaucitron.parameters.orientation==="middle"){document.getElementById("tarteaucitronAlertBig").focus()}if(typeof window.dispatchEvent==="function"){window.dispatchEvent(tacOpenAlertEvent)}},closeAlert:function(){"use strict";var c="tarteaucitron";tarteaucitron.userInterface.css(c+"Percentage","display","none");tarteaucitron.userInterface.css(c+"AlertSmall","display","block");tarteaucitron.userInterface.css(c+"Icon","display","block");tarteaucitron.userInterface.css(c+"AlertBig","display","none");tarteaucitron.userInterface.removeClass(c+"Root","tarteaucitronBeforeVisible");tarteaucitron.userInterface.jsSizing("box");var tacCloseAlertEvent;if(typeof Event==="function"){tacCloseAlertEvent=new Event("tac.close_alert")}else if(typeof document.createEvent==="function"){tacCloseAlertEvent=document.createEvent("Event");tacCloseAlertEvent.initEvent("tac.close_alert",true,true)}if(typeof window.dispatchEvent==="function"){window.dispatchEvent(tacCloseAlertEvent)}},toggleCookiesList:function(){"use strict";var div=document.getElementById("tarteaucitronCookiesListContainer"),togglediv=document.getElementById("tarteaucitronCookiesNumber");if(div===null){return}if(div.style.display!=="block"){tarteaucitron.cookie.number();div.style.display="block";togglediv.setAttribute("aria-expanded","true");tarteaucitron.userInterface.jsSizing("cookie");tarteaucitron.userInterface.css("tarteaucitron","display","none");tarteaucitron.userInterface.css("tarteaucitronBack","display","block");tarteaucitron.fallback(["tarteaucitronInfoBox"],function(elem){elem.style.display="none"},true)}else{div.style.display="none";togglediv.setAttribute("aria-expanded","false");tarteaucitron.userInterface.css("tarteaucitron","display","none");tarteaucitron.userInterface.css("tarteaucitronBack","display","none")}},toggle:function(id,closeClass){"use strict";var div=document.getElementById(id);if(div===null){return}if(closeClass!==undefined){tarteaucitron.fallback([closeClass],function(elem){if(elem.id!==id){elem.style.display="none"}},true)}if(div.style.display!=="block"){div.style.display="block"}else{div.style.display="none"}},order:function(id){"use strict";var main=document.getElementById("tarteaucitronServices_"+id),allDivs,store=[],i;if(main===null){return}allDivs=main.childNodes;if(typeof Array.prototype.map==="function"&&typeof Enumerable==="undefined"){Array.prototype.map.call(main.children,Object).sort(function(a,b){if(tarteaucitron.services[a.id.replace(/Line/g,"")].name>tarteaucitron.services[b.id.replace(/Line/g,"")].name){return 1}if(tarteaucitron.services[a.id.replace(/Line/g,"")].name<tarteaucitron.services[b.id.replace(/Line/g,"")].name){return-1}return 0}).forEach(function(element){main.appendChild(element)})}},jsSizing:function(type){"use strict";var scrollbarMarginRight=10,scrollbarWidthParent,scrollbarWidthChild,servicesHeight,e=window,a="inner",windowInnerHeight=window.innerHeight||document.documentElement.clientHeight||document.body.clientHeight,mainTop,mainHeight,closeButtonHeight,headerHeight,cookiesListHeight,cookiesCloseHeight,cookiesTitleHeight,paddingBox,alertSmallHeight,cookiesNumberHeight;if(type==="box"){if(document.getElementById("tarteaucitronAlertSmall")!==null&&document.getElementById("tarteaucitronCookiesNumber")!==null){tarteaucitron.userInterface.css("tarteaucitronCookiesNumber","padding","0px 10px");alertSmallHeight=document.getElementById("tarteaucitronAlertSmall").offsetHeight;cookiesNumberHeight=document.getElementById("tarteaucitronCookiesNumber").offsetHeight;paddingBox=(alertSmallHeight-cookiesNumberHeight)/2;tarteaucitron.userInterface.css("tarteaucitronCookiesNumber","padding",paddingBox+"px 10px")}}else if(type==="main"){if(window.innerWidth===undefined){a="client";e=document.documentElement||document.body}if(document.getElementById("tarteaucitron")!==null&&document.getElementById("tarteaucitronClosePanel")!==null&&document.getElementById("tarteaucitronMainLineOffset")!==null){tarteaucitron.userInterface.css("tarteaucitronServices","height","auto");mainHeight=document.getElementById("tarteaucitron").offsetHeight;closeButtonHeight=document.getElementById("tarteaucitronClosePanel").offsetHeight;servicesHeight=mainHeight-closeButtonHeight+4;tarteaucitron.userInterface.css("tarteaucitronServices","height",servicesHeight+"px");tarteaucitron.userInterface.css("tarteaucitronServices","overflow-x","auto")}if(document.getElementById("tarteaucitronServices")!==null&&document.getElementById("tarteaucitronScrollbarChild")!==null){if(e[a+"Width"]<=479){}else if(e[a+"Width"]<=767){scrollbarMarginRight=12}scrollbarWidthParent=document.getElementById("tarteaucitronServices").offsetWidth;scrollbarWidthChild=document.getElementById("tarteaucitronScrollbarChild").offsetWidth}if(document.getElementById("tarteaucitron")!==null){if(e[a+"Width"]<=767){mainTop=0}else{mainTop=(windowInnerHeight-document.getElementById("tarteaucitron").offsetHeight)/2-21}if(document.getElementById("tarteaucitronMainLineOffset")!==null){if(document.getElementById("tarteaucitron").offsetHeight<windowInnerHeight/2){mainTop-=document.getElementById("tarteaucitronMainLineOffset").offsetHeight}}if(mainTop<0){mainTop=0}tarteaucitron.userInterface.css("tarteaucitron","top",mainTop+"px")}}else if(type==="cookie"){if(document.getElementById("tarteaucitronAlertSmall")!==null){tarteaucitron.userInterface.css("tarteaucitronCookiesListContainer","bottom",document.getElementById("tarteaucitronAlertSmall").offsetHeight+"px")}if(document.getElementById("tarteaucitronCookiesListContainer")!==null){tarteaucitron.userInterface.css("tarteaucitronCookiesList","height","auto");cookiesListHeight=document.getElementById("tarteaucitronCookiesListContainer").offsetHeight;cookiesCloseHeight=document.getElementById("tarteaucitronClosePanelCookie").offsetHeight;cookiesTitleHeight=document.getElementById("tarteaucitronCookiesTitle").offsetHeight;tarteaucitron.userInterface.css("tarteaucitronCookiesList","height",cookiesListHeight-cookiesCloseHeight-cookiesTitleHeight-2+"px")}}}},cookie:{owner:{},create:function(key,status){"use strict";if(tarteaucitronForceExpire!==""){if(tarteaucitronExpireInDay&&tarteaucitronForceExpire<365||!tarteaucitronExpireInDay&&tarteaucitronForceExpire<8760){if(tarteaucitronExpireInDay){timeExpire=tarteaucitronForceExpire*864e5}else{timeExpire=tarteaucitronForceExpire*36e5}}}var d=new Date,time=d.getTime(),expireTime=time+timeExpire,regex=new RegExp("!"+key+"=(wait|true|false)","g"),cookie=tarteaucitron.cookie.read().replace(regex,""),value=tarteaucitron.parameters.cookieName+"="+cookie+"!"+key+"="+status,domain=tarteaucitron.parameters.cookieDomain!==undefined&&tarteaucitron.parameters.cookieDomain!==""?"; domain="+tarteaucitron.parameters.cookieDomain:"",secure=location.protocol==="https:"?"; Secure":"";d.setTime(expireTime);document.cookie=value+"; expires="+d.toGMTString()+"; path=/"+domain+secure+"; samesite=lax";tarteaucitron.sendEvent("tac.consent_updated")},read:function(){"use strict";var nameEQ=tarteaucitron.parameters.cookieName+"=",ca=document.cookie.split(";"),i,c;for(i=0;i<ca.length;i+=1){c=ca[i];while(c.charAt(0)===" "){c=c.substring(1,c.length)}if(c.indexOf(nameEQ)===0){return c.substring(nameEQ.length,c.length)}}return""},purge:function(arr){"use strict";var i;for(i=0;i<arr.length;i+=1){var rgxpCookie=new RegExp("^(.*;)?\\s*"+arr[i]+"\\s*=\\s*[^;]+(.*)?$");if(document.cookie.match(rgxpCookie)){document.cookie=arr[i]+"=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/;";document.cookie=arr[i]+"=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=."+location.hostname+";";document.cookie=arr[i]+"=; expires=Thu, 01 Jan 2000 00:00:00 GMT; path=/; domain=."+location.hostname.split(".").slice(-2).join(".")+";"}}},checkCount:function(key){"use strict";var arr=tarteaucitron.services[key].cookies,nb=arr.length,nbCurrent=0,html="",i,status=document.cookie.indexOf(key+"=true");if(status>=0&&nb===0){html+=tarteaucitron.lang.useNoCookie}else if(status>=0){for(i=0;i<nb;i+=1){if(document.cookie.indexOf(arr[i]+"=")!==-1){nbCurrent+=1;if(tarteaucitron.cookie.owner[arr[i]]===undefined){tarteaucitron.cookie.owner[arr[i]]=[]}if(tarteaucitron.cookie.crossIndexOf(tarteaucitron.cookie.owner[arr[i]],tarteaucitron.services[key].name)===false){tarteaucitron.cookie.owner[arr[i]].push(tarteaucitron.services[key].name)}}}if(nbCurrent>0){html+=tarteaucitron.lang.useCookieCurrent+" "+nbCurrent+" cookie";if(nbCurrent>1){html+="s"}html+="."}else{html+=tarteaucitron.lang.useNoCookie}}else if(nb===0){html=tarteaucitron.lang.noCookie}else{html+=tarteaucitron.lang.useCookie+" "+nb+" cookie";if(nb>1){html+="s"}html+="."}if(document.getElementById("tacCL"+key)!==null){document.getElementById("tacCL"+key).innerHTML=html}},crossIndexOf:function(arr,match){"use strict";var i;for(i=0;i<arr.length;i+=1){if(arr[i]===match){return true}}return false},number:function(){"use strict";var cookies=document.cookie.split(";"),nb=document.cookie!==""?cookies.length:0,html="",i,name,namea,nameb,c,d,s=nb>1?"s":"",savedname,regex=/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i,regexedDomain=tarteaucitron.cdn.match(regex)!==null?tarteaucitron.cdn.match(regex)[1]:tarteaucitron.cdn,host=tarteaucitron.domain!==undefined?tarteaucitron.domain:regexedDomain;cookies=cookies.sort(function(a,b){namea=a.split("=",1).toString().replace(/ /g,"");nameb=b.split("=",1).toString().replace(/ /g,"");c=tarteaucitron.cookie.owner[namea]!==undefined?tarteaucitron.cookie.owner[namea]:"0";d=tarteaucitron.cookie.owner[nameb]!==undefined?tarteaucitron.cookie.owner[nameb]:"0";if(c+a>d+b){return 1}if(c+a<d+b){return-1}return 0});if(document.cookie!==""){for(i=0;i<nb;i+=1){name=cookies[i].split("=",1).toString().replace(/ /g,"");if(tarteaucitron.cookie.owner[name]!==undefined&&tarteaucitron.cookie.owner[name].join(" // ")!==savedname){savedname=tarteaucitron.cookie.owner[name].join(" // ");html+='<div class="tarteaucitronHidden">';html+='     <span class="tarteaucitronTitle tarteaucitronH3" role="heading" aria-level="3">';html+="        "+tarteaucitron.cookie.owner[name].join(" // ");html+="    </span>";html+='</div><ul class="cookie-list">'}else if(tarteaucitron.cookie.owner[name]===undefined&&host!==savedname){savedname=host;html+='<div class="tarteaucitronHidden">';html+='     <span class="tarteaucitronTitle tarteaucitronH3" role="heading" aria-level="3">';html+="        "+host;html+="    </span>";html+='</div><ul class="cookie-list">'}html+='<li class="tarteaucitronCookiesListMain">';html+='    <div class="tarteaucitronCookiesListLeft"><button type="button" class="purgeBtn" data-cookie="'+tarteaucitron.fixSelfXSS(cookies[i].split("=",1))+'"><strong>&times;</strong></button> <strong>'+tarteaucitron.fixSelfXSS(name)+"</strong>";html+="    </div>";html+='    <div class="tarteaucitronCookiesListRight">'+tarteaucitron.fixSelfXSS(cookies[i].split("=").slice(1).join("="))+"</div>";html+="</li>"}html+="</ul>"}else{html+='<div class="tarteaucitronCookiesListMain">';html+='    <div class="tarteaucitronCookiesListLeft"><strong>-</strong></div>';html+='    <div class="tarteaucitronCookiesListRight"></div>';html+="</div>"}html+='<div class="tarteaucitronHidden tarteaucitron-spacer-20"></div>';if(document.getElementById("tarteaucitronCookiesList")!==null){document.getElementById("tarteaucitronCookiesList").innerHTML=html}if(document.getElementById("tarteaucitronCookiesNumber")!==null){document.getElementById("tarteaucitronCookiesNumber").innerHTML=nb;document.getElementById("tarteaucitronCookiesNumber").setAttribute("aria-label",nb+" cookie"+s+" - "+tarteaucitron.lang.toggleInfoBox);document.getElementById("tarteaucitronCookiesNumber").setAttribute("title",nb+" cookie"+s+" - "+tarteaucitron.lang.toggleInfoBox)}if(document.getElementById("tarteaucitronCookiesNumberBis")!==null){document.getElementById("tarteaucitronCookiesNumberBis").innerHTML=nb+" cookie"+s}var purgeBtns=document.getElementsByClassName("purgeBtn");for(i=0;i<purgeBtns.length;i++){tarteaucitron.addClickEventToElement(purgeBtns[i],function(){tarteaucitron.cookie.purge([this.dataset.cookie]);tarteaucitron.cookie.number();tarteaucitron.userInterface.jsSizing("cookie");return false})}for(i=0;i<tarteaucitron.job.length;i+=1){tarteaucitron.cookie.checkCount(tarteaucitron.job[i])}}},fixSelfXSS:function(html){return html.toString().replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#039;")},getLanguage:function(){"use strict";var availableLanguages="ar,bg,ca,cn,cs,da,de,et,el,en,es,fi,fr,hu,it,ja,lb,lt,lv,nl,no,oc,pl,pt,ro,ru,se,sk,sv,tr,uk,vi,zh",defaultLanguage="en";if(tarteaucitronForceLanguage!==""){if(availableLanguages.indexOf(tarteaucitronForceLanguage)!==-1){return tarteaucitronForceLanguage}}if(availableLanguages.indexOf(document.documentElement.getAttribute("lang").substr(0,2))!==-1){return document.documentElement.getAttribute("lang").substr(0,2)}if(!navigator){return defaultLanguage}var lang=navigator.language||navigator.browserLanguage||navigator.systemLanguage||navigator.userLang||null,userLanguage=lang?lang.substr(0,2):null;if(availableLanguages.indexOf(userLanguage)!==-1){return userLanguage}return defaultLanguage},getLocale:function(){"use strict";if(!navigator){return"en_US"}var lang=navigator.language||navigator.browserLanguage||navigator.systemLanguage||navigator.userLang||null,userLanguage=lang?lang.substr(0,2):null;if(userLanguage==="fr"){return"fr_FR"}else if(userLanguage==="en"){return"en_US"}else if(userLanguage==="de"){return"de_DE"}else if(userLanguage==="es"){return"es_ES"}else if(userLanguage==="it"){return"it_IT"}else if(userLanguage==="pt"){return"pt_PT"}else if(userLanguage==="nl"){return"nl_NL"}else if(userLanguage==="el"){return"el_EL"}else{return"en_US"}},addScript:function(url,id,callback,execute,attrName,attrVal,internal){"use strict";var script,done=false;if(execute===false){if(typeof callback==="function"){callback()}}else{script=document.createElement("script");if(id!==undefined){script.id=id}script.async=true;script.src=url;if(attrName!==undefined&&attrVal!==undefined){script.setAttribute(attrName,attrVal)}if(typeof callback==="function"){if(!tarteaucitron.parameters.useExternalJs||!internal){script.onreadystatechange=script.onload=function(){var state=script.readyState;if(!done&&(!state||/loaded|complete/.test(state))){done=true;callback()}}}else{callback()}}if(!tarteaucitron.parameters.useExternalJs||!internal){document.getElementsByTagName("head")[0].appendChild(script)}}},addInternalScript:function(url,id,callback,execute,attrName,attrVal){tarteaucitron.addScript(url,id,callback,execute,attrName,attrVal,true)},checkIfExist:function(elemId){"use strict";return document.getElementById(elemId)!==null&&document.getElementById(elemId).offsetWidth!==0&&document.getElementById(elemId).offsetHeight!==0},makeAsync:{antiGhost:0,buffer:"",init:function(url,id){"use strict";var savedWrite=document.write,savedWriteln=document.writeln;document.write=function(content){tarteaucitron.makeAsync.buffer+=content};document.writeln=function(content){tarteaucitron.makeAsync.buffer+=content.concat("\n")};setTimeout(function(){document.write=savedWrite;document.writeln=savedWriteln},2e4);tarteaucitron.makeAsync.getAndParse(url,id)},getAndParse:function(url,id){"use strict";if(tarteaucitron.makeAsync.antiGhost>9){tarteaucitron.makeAsync.antiGhost=0;return}tarteaucitron.makeAsync.antiGhost+=1;tarteaucitron.addInternalScript(url,"",function(){if(document.getElementById(id)!==null){document.getElementById(id).innerHTML+="<span class='tarteaucitron-display-none'>&nbsp;</span>"+tarteaucitron.makeAsync.buffer;tarteaucitron.makeAsync.buffer="";tarteaucitron.makeAsync.execJS(id)}})},execJS:function(id){var i,scripts,childId,type;if(document.getElementById(id)===null){return}scripts=document.getElementById(id).getElementsByTagName("script");for(i=0;i<scripts.length;i+=1){type=scripts[i].getAttribute("type")!==null?scripts[i].getAttribute("type"):"";if(type===""){type=scripts[i].getAttribute("language")!==null?scripts[i].getAttribute("language"):""}if(scripts[i].getAttribute("src")!==null&&scripts[i].getAttribute("src")!==""){childId=id+Math.floor(Math.random()*99999999999);document.getElementById(id).innerHTML+='<div id="'+childId+'"></div>';tarteaucitron.makeAsync.getAndParse(scripts[i].getAttribute("src"),childId)}else if(type.indexOf("javascript")!==-1||type===""){eval(scripts[i].innerHTML)}}}},fallback:function(matchClass,content,noInner){"use strict";var elems=document.getElementsByTagName("*"),i,index=0;for(i in elems){if(elems[i]!==undefined){for(index=0;index<matchClass.length;index+=1){if((" "+elems[i].className+" ").indexOf(" "+matchClass[index]+" ")>-1){if(typeof content==="function"){if(noInner===true){content(elems[i])}else{elems[i].innerHTML=content(elems[i])}}else{elems[i].innerHTML=content}}}}}},engage:function(id){"use strict";var html="",r=Math.floor(Math.random()*1e5),engage=tarteaucitron.services[id].name+" "+tarteaucitron.lang.fallback;if(tarteaucitron.lang["engage-"+id]!==undefined){engage=tarteaucitron.lang["engage-"+id]}html+='<div class="tac_activate tac_activate_'+id+'">';html+='   <div class="tac_float">';html+="      "+engage;html+='      <button type="button" class="tarteaucitronAllow" id="Eng'+r+"ed"+id+'">';html+='          <span class="tarteaucitronCheck" aria-hidden="true"></span> '+tarteaucitron.lang.allow;html+="       </button>";html+="   </div>";html+="</div>";return html},extend:function(a,b){"use strict";var prop;for(prop in b){if(b.hasOwnProperty(prop)){a[prop]=b[prop]}}},proTemp:"",proTimer:function(){"use strict";setTimeout(tarteaucitron.proPing,Math.floor(Math.random()*(1200-500+1))+500)},pro:function(list){"use strict";tarteaucitron.proTemp+=list;clearTimeout(tarteaucitron.proTimer);tarteaucitron.proTimer=setTimeout(tarteaucitron.proPing,Math.floor(Math.random()*(1200-500+1))+500)},proPing:function(){"use strict";if(tarteaucitron.uuid!==""&&tarteaucitron.uuid!==undefined&&tarteaucitron.proTemp!==""&&tarteaucitronStatsEnabled){var div=document.getElementById("tarteaucitronPremium"),timestamp=(new Date).getTime(),url="https://tarteaucitron.io/log/?";if(div===null){return}url+="account="+tarteaucitron.uuid+"&";url+="domain="+tarteaucitron.domain+"&";url+="status="+encodeURIComponent(tarteaucitron.proTemp)+"&";url+="_time="+timestamp;div.innerHTML='<img src="'+url+'" class="tarteaucitron-display-none" alt="" />';tarteaucitron.proTemp=""}tarteaucitron.cookie.number()},AddOrUpdate:function(source,custom){for(var key in custom){if(custom[key]instanceof Object){source[key]=tarteaucitron.AddOrUpdate(source[key],custom[key])}else{source[key]=custom[key]}}return source},getElemWidth:function(elem){return tarteaucitron.getElemAttr(elem,"width")||elem.clientWidth},getElemHeight:function(elem){return tarteaucitron.getElemAttr(elem,"height")||elem.clientHeight},getElemAttr:function(elem,attr){var attribute=elem.getAttribute("data-"+attr)||elem.getAttribute(attr);if(typeof attribute==="string"){return tarteaucitron.fixSelfXSS(attribute)}return""},addClickEventToId:function(elemId,func){tarteaucitron.addClickEventToElement(document.getElementById(elemId),func)},addClickEventToElement:function(e,func){if(e){if(e.addEventListener){e.addEventListener("click",func)}else{e.attachEvent("onclick",func)}}},triggerJobsAfterAjaxCall:function(){tarteaucitron.job.forEach(function(e){tarteaucitron.job.push(e)});var i;var allowBtns=document.getElementsByClassName("tarteaucitronAllow");for(i=0;i<allowBtns.length;i++){tarteaucitron.addClickEventToElement(allowBtns[i],function(){tarteaucitron.userInterface.respond(this,true)})}var denyBtns=document.getElementsByClassName("tarteaucitronDeny");for(i=0;i<denyBtns.length;i++){tarteaucitron.addClickEventToElement(denyBtns[i],function(){tarteaucitron.userInterface.respond(this,false)})}}};
/*
 *  Remodal - v1.1.1
 *  Responsive, lightweight, fast, synchronized with CSS animations, fully customizable modal window plugin with declarative configuration and hash tracking.
 *  http://vodkabears.github.io/remodal/
 *
 *  Made by Ilya Makarov
 *  Under MIT License
 */

!function(a,b){"function"==typeof define&&define.amd?define(["jquery"],function(c){return b(a,c)}):"object"==typeof exports?b(a,require("jquery")):b(a,a.jQuery||a.Zepto)}(this,function(a,b){"use strict";function c(a){if(w&&"none"===a.css("animation-name")&&"none"===a.css("-webkit-animation-name")&&"none"===a.css("-moz-animation-name")&&"none"===a.css("-o-animation-name")&&"none"===a.css("-ms-animation-name"))return 0;var b,c,d,e,f=a.css("animation-duration")||a.css("-webkit-animation-duration")||a.css("-moz-animation-duration")||a.css("-o-animation-duration")||a.css("-ms-animation-duration")||"0s",g=a.css("animation-delay")||a.css("-webkit-animation-delay")||a.css("-moz-animation-delay")||a.css("-o-animation-delay")||a.css("-ms-animation-delay")||"0s",h=a.css("animation-iteration-count")||a.css("-webkit-animation-iteration-count")||a.css("-moz-animation-iteration-count")||a.css("-o-animation-iteration-count")||a.css("-ms-animation-iteration-count")||"1";for(f=f.split(", "),g=g.split(", "),h=h.split(", "),e=0,c=f.length,b=Number.NEGATIVE_INFINITY;e<c;e++)d=parseFloat(f[e])*parseInt(h[e],10)+parseFloat(g[e]),d>b&&(b=d);return b}function d(){if(b(document).height()<=b(window).height())return 0;var a,c,d=document.createElement("div"),e=document.createElement("div");return d.style.visibility="hidden",d.style.width="100px",document.body.appendChild(d),a=d.offsetWidth,d.style.overflow="scroll",e.style.width="100%",d.appendChild(e),c=e.offsetWidth,d.parentNode.removeChild(d),a-c}function e(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)||(c=b(document.body),a=parseInt(c.css("padding-right"),10)+d(),c.css("padding-right",a+"px"),e.addClass(f))}}function f(){if(!x){var a,c,e=b("html"),f=k("is-locked");e.hasClass(f)&&(c=b(document.body),a=parseInt(c.css("padding-right"),10)-d(),c.css("padding-right",a+"px"),e.removeClass(f))}}function g(a,b,c,d){var e=k("is",b),f=[k("is",u.CLOSING),k("is",u.OPENING),k("is",u.CLOSED),k("is",u.OPENED)].join(" ");a.$bg.removeClass(f).addClass(e),a.$overlay.removeClass(f).addClass(e),a.$wrapper.removeClass(f).addClass(e),a.$modal.removeClass(f).addClass(e),a.state=b,!c&&a.$modal.trigger({type:b,reason:d},[{reason:d}])}function h(a,d,e){var f=0,g=function(a){a.target===this&&f++},h=function(a){a.target===this&&0===--f&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())};b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].on(r,g).on(s,h)}),a(),0===c(e.$bg)&&0===c(e.$overlay)&&0===c(e.$wrapper)&&0===c(e.$modal)&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(a,b){e[b].off(r+" "+s)}),d())}function i(a){a.state!==u.CLOSED&&(b.each(["$bg","$overlay","$wrapper","$modal"],function(b,c){a[c].off(r+" "+s)}),a.$bg.removeClass(a.settings.modifier),a.$overlay.removeClass(a.settings.modifier).hide(),a.$wrapper.hide(),f(),g(a,u.CLOSED,!0))}function j(a){var b,c,d,e,f={};for(a=a.replace(/\s*:\s*/g,":").replace(/\s*,\s*/g,","),b=a.split(","),e=0,c=b.length;e<c;e++)b[e]=b[e].split(":"),d=b[e][1],("string"==typeof d||d instanceof String)&&(d="true"===d||"false"!==d&&d),("string"==typeof d||d instanceof String)&&(d=isNaN(d)?d:+d),f[b[e][0]]=d;return f}function k(){for(var a=q,b=0;b<arguments.length;++b)a+="-"+arguments[b];return a}function l(){var a,c,d=location.hash.replace("#","");if(d){try{c=b('[data-remodal-id="'+d+'"]')}catch(e){}c&&c.length&&(a=b[p].lookup[c.data(p)],a&&a.settings.hashTracking&&a.open())}else n&&n.state===u.OPENED&&n.settings.hashTracking&&n.close()}function m(a,c){var d=b(document.body),e=d,f=this;f.settings=b.extend({},t,c),f.index=b[p].lookup.push(f)-1,f.state=u.CLOSED,f.$overlay=b("."+k("overlay")),null!==f.settings.appendTo&&f.settings.appendTo.length&&(e=b(f.settings.appendTo)),f.$overlay.length||(f.$overlay=b("<div>").addClass(k("overlay")+" "+k("is",u.CLOSED)).hide(),e.append(f.$overlay)),f.$bg=b("."+k("bg")).addClass(k("is",u.CLOSED)),f.$modal=a.addClass(q+" "+k("is-initialized")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).attr("tabindex","-1"),f.$wrapper=b("<div>").addClass(k("wrapper")+" "+f.settings.modifier+" "+k("is",u.CLOSED)).hide().append(f.$modal),e.append(f.$wrapper),f.$wrapper.on("click."+q,'[data-remodal-action="close"]',function(a){a.preventDefault(),f.close()}),f.$wrapper.on("click."+q,'[data-remodal-action="cancel"]',function(a){a.preventDefault(),f.$modal.trigger(v.CANCELLATION),f.settings.closeOnCancel&&f.close(v.CANCELLATION)}),f.$wrapper.on("click."+q,'[data-remodal-action="confirm"]',function(a){a.preventDefault(),f.$modal.trigger(v.CONFIRMATION),f.settings.closeOnConfirm&&f.close(v.CONFIRMATION)}),f.$wrapper.on("click."+q,function(a){var c=b(a.target);c.hasClass(k("wrapper"))&&f.settings.closeOnOutsideClick&&f.close()})}var n,o,p="remodal",q=a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.NAMESPACE||p,r=b.map(["animationstart","webkitAnimationStart","MSAnimationStart","oAnimationStart"],function(a){return a+"."+q}).join(" "),s=b.map(["animationend","webkitAnimationEnd","MSAnimationEnd","oAnimationEnd"],function(a){return a+"."+q}).join(" "),t=b.extend({hashTracking:!0,closeOnConfirm:!0,closeOnCancel:!0,closeOnEscape:!0,closeOnOutsideClick:!0,modifier:"",appendTo:null},a.REMODAL_GLOBALS&&a.REMODAL_GLOBALS.DEFAULTS),u={CLOSING:"closing",CLOSED:"closed",OPENING:"opening",OPENED:"opened"},v={CONFIRMATION:"confirmation",CANCELLATION:"cancellation"},w=function(){var a=document.createElement("div").style;return void 0!==a.animationName||void 0!==a.WebkitAnimationName||void 0!==a.MozAnimationName||void 0!==a.msAnimationName||void 0!==a.OAnimationName}(),x=/iPad|iPhone|iPod/.test(navigator.platform);m.prototype.open=function(){var a,c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&(a=c.$modal.attr("data-remodal-id"),a&&c.settings.hashTracking&&(o=b(window).scrollTop(),location.hash=a),n&&n!==c&&i(n),n=c,e(),c.$bg.addClass(c.settings.modifier),c.$overlay.addClass(c.settings.modifier).show(),c.$wrapper.show().scrollTop(0),c.$modal.focus(),h(function(){g(c,u.OPENING)},function(){g(c,u.OPENED)},c))},m.prototype.close=function(a){var c=this;c.state!==u.OPENING&&c.state!==u.CLOSING&&c.state!==u.CLOSED&&(c.settings.hashTracking&&c.$modal.attr("data-remodal-id")===location.hash.substr(1)&&(location.hash="",b(window).scrollTop(o)),h(function(){g(c,u.CLOSING,!1,a)},function(){c.$bg.removeClass(c.settings.modifier),c.$overlay.removeClass(c.settings.modifier).hide(),c.$wrapper.hide(),f(),g(c,u.CLOSED,!1,a)},c))},m.prototype.getState=function(){return this.state},m.prototype.destroy=function(){var a,c=b[p].lookup;i(this),this.$wrapper.remove(),delete c[this.index],a=b.grep(c,function(a){return!!a}).length,0===a&&(this.$overlay.remove(),this.$bg.removeClass(k("is",u.CLOSING)+" "+k("is",u.OPENING)+" "+k("is",u.CLOSED)+" "+k("is",u.OPENED)))},b[p]={lookup:[]},b.fn[p]=function(a){var c,d;return this.each(function(e,f){d=b(f),null==d.data(p)?(c=new m(d,a),d.data(p,c.index),c.settings.hashTracking&&d.attr("data-remodal-id")===location.hash.substr(1)&&c.open()):c=b[p].lookup[d.data(p)]}),c},b(document).ready(function(){b(document).on("click","[data-remodal-target]",function(a){a.preventDefault();var c=a.currentTarget,d=c.getAttribute("data-remodal-target"),e=b('[data-remodal-id="'+d+'"]');b[p].lookup[e.data(p)].open()}),b(document).find("."+q).each(function(a,c){var d=b(c),e=d.data("remodal-options");e?("string"==typeof e||e instanceof String)&&(e=j(e)):e={},d[p](e)}),b(document).on("keydown."+q,function(a){n&&n.settings.closeOnEscape&&n.state===u.OPENED&&27===a.keyCode&&n.close()}),b(window).on("hashchange."+q,l)})});
!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

var _extends=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o])}return e},_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};!function(e,t){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.LazyLoad=t()}(this,function(){"use strict";var e=function(){return{elements_selector:"img",container:window,threshold:300,throttle:150,data_src:"src",data_srcset:"srcset",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_initial:"initial",skip_invisible:!0,callback_load:null,callback_error:null,callback_set:null,callback_processed:null,callback_enter:null}},t=!("onscroll"in window)||/glebot/.test(navigator.userAgent),n=function(e,t){e&&e(t)},o=function(e){return e.getBoundingClientRect().top+window.pageYOffset-e.ownerDocument.documentElement.clientTop},i=function(e,t,n){return(t===window?window.innerHeight+window.pageYOffset:o(t)+t.offsetHeight)<=o(e)-n},s=function(e){return e.getBoundingClientRect().left+window.pageXOffset-e.ownerDocument.documentElement.clientLeft},r=function(e,t,n){var o=window.innerWidth;return(t===window?o+window.pageXOffset:s(t)+o)<=s(e)-n},l=function(e,t,n){return(t===window?window.pageYOffset:o(t))>=o(e)+n+e.offsetHeight},a=function(e,t,n){return(t===window?window.pageXOffset:s(t))>=s(e)+n+e.offsetWidth},c=function(e,t,n){return!(i(e,t,n)||l(e,t,n)||r(e,t,n)||a(e,t,n))},u=function(e,t){var n,o=new e(t);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(e){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)},d=function(e,t){return e.getAttribute("data-"+t)},h=function(e,t,n){return e.setAttribute("data-"+t,n)},f=function(e,t){var n=e.parentNode;if(!n||"PICTURE"===n.tagName)for(var o=0;o<n.children.length;o++){var i=n.children[o];if("SOURCE"===i.tagName){var s=d(i,t);s&&i.setAttribute("srcset",s)}}},_=function(e,t,n){var o=e.tagName,i=d(e,n);if("IMG"===o){f(e,t);var s=d(e,t);return s&&e.setAttribute("srcset",s),void(i&&e.setAttribute("src",i))}"IFRAME"!==o?i&&(e.style.backgroundImage='url("'+i+'")'):i&&e.setAttribute("src",i)},p="undefined"!=typeof window,m=p&&"classList"in document.createElement("p"),g=function(e,t){m?e.classList.add(t):e.className+=(e.className?" ":"")+t},v=function(e,t){m?e.classList.remove(t):e.className=e.className.replace(new RegExp("(^|\\s+)"+t+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},w=function(t){this._settings=_extends({},e(),t),this._queryOriginNode=this._settings.container===window?document:this._settings.container,this._previousLoopTime=0,this._loopTimeout=null,this._boundHandleScroll=this.handleScroll.bind(this),this._isFirstLoop=!0,window.addEventListener("resize",this._boundHandleScroll),this.update()};w.prototype={_reveal:function(e){var t=this._settings,o=function o(){t&&(e.removeEventListener("load",i),e.removeEventListener("error",o),v(e,t.class_loading),g(e,t.class_error),n(t.callback_error,e))},i=function i(){t&&(v(e,t.class_loading),g(e,t.class_loaded),e.removeEventListener("load",i),e.removeEventListener("error",o),n(t.callback_load,e))};n(t.callback_enter,e),"IMG"!==e.tagName&&"IFRAME"!==e.tagName||(e.addEventListener("load",i),e.addEventListener("error",o),g(e,t.class_loading)),_(e,t.data_srcset,t.data_src),n(t.callback_set,e)},_loopThroughElements:function(){var e=this._settings,o=this._elements,i=o?o.length:0,s=void 0,r=[],l=this._isFirstLoop;for(s=0;s<i;s++){var a=o[s];e.skip_invisible&&null===a.offsetParent||(t||c(a,e.container,e.threshold))&&(l&&g(a,e.class_initial),this._reveal(a),r.push(s),h(a,"was-processed",!0))}for(;r.length;)o.splice(r.pop(),1),n(e.callback_processed,o.length);0===i&&this._stopScrollHandler(),l&&(this._isFirstLoop=!1)},_purgeElements:function(){var e=this._elements,t=e.length,n=void 0,o=[];for(n=0;n<t;n++){var i=e[n];d(i,"was-processed")&&o.push(n)}for(;o.length>0;)e.splice(o.pop(),1)},_startScrollHandler:function(){this._isHandlingScroll||(this._isHandlingScroll=!0,this._settings.container.addEventListener("scroll",this._boundHandleScroll))},_stopScrollHandler:function(){this._isHandlingScroll&&(this._isHandlingScroll=!1,this._settings.container.removeEventListener("scroll",this._boundHandleScroll))},handleScroll:function(){var e=this._settings.throttle;if(0!==e){var t=Date.now(),n=e-(t-this._previousLoopTime);n<=0||n>e?(this._loopTimeout&&(clearTimeout(this._loopTimeout),this._loopTimeout=null),this._previousLoopTime=t,this._loopThroughElements()):this._loopTimeout||(this._loopTimeout=setTimeout(function(){this._previousLoopTime=Date.now(),this._loopTimeout=null,this._loopThroughElements()}.bind(this),n))}else this._loopThroughElements()},update:function(){this._elements=Array.prototype.slice.call(this._queryOriginNode.querySelectorAll(this._settings.elements_selector)),this._purgeElements(),this._loopThroughElements(),this._startScrollHandler()},destroy:function(){window.removeEventListener("resize",this._boundHandleScroll),this._loopTimeout&&(clearTimeout(this._loopTimeout),this._loopTimeout=null),this._stopScrollHandler(),this._elements=null,this._queryOriginNode=null,this._settings=null}};var b=window.lazyLoadOptions;return p&&b&&function(e,t){var n=t.length;if(n)for(var o=0;o<n;o++)u(e,t[o]);else u(e,t)}(w,b),w});